import { Component, Emit, Prop, Vue,Watch } from 'vue-property-decorator';
import SelectPlanting from '@/components/SelectPlanting/SelectPlanting.vue';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue'
import SelectFromAgriFields from '@/components/Record/SelectFromAgriFields/SelectFromAgriFields.vue'
import SelectTime from '@/components/Record/WorkRecord/SelectTime/SelectTime.vue'
import SelectInterval from '@/components/Record/WorkRecord/SelectInterval/SelectInterval.vue'
import WorkItemSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkItemModal/WorkItemSelectModal.vue'
import MachineSelectModal from '@/assets/common/Modal/ItemSelectModal/MachineSelectModal/MachineSelectModal.vue'
import WorkerSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkerSelectModal/WorkerSelectModal.vue'
import PesticideSelectionModal from '@/assets/common/Modal/PesticideSelectionModal/PesticideSelectionModal.vue'
import FertilizerSelectionModal from '@/assets/common/Modal/FertilizerSelectionModal/FertilizerSelectionModal.vue'
import RecordInfo from '@/components/Record/RecordInfo/RecordInfo.vue'
import moment from 'moment';
import {
    File,
    WorkRecordGet,
    Worker,
    Machine,
    RecordInfoModel,
    SelectAgriFieldAndPlanting,
    WorkTimeState,
    Item, ChemicalRecord, FertilizerRecord, ExpendableMaterialRecord, DepreciationMaterialRecord,
    WarehouseChemicalWithWPU
} from '@/types/Component';
import { toCamel } from 'snake-camel';
import SelectChemicals from '@/components/Record/WorkRecord/SelectChemicals/SelectChemicals.vue';
import SelectFertilizers from '@/components/Record/WorkRecord/SelectFertilizers/SelectFertilizers.vue';
import SelectDepreciationMaterials from '@/components/Record/WorkRecord/SelectDeprecationMaterials/SelectDeprecationMaterials.vue'
import SelectExpendableMaterials from '@/components/Record/WorkRecord/SelectExpendableMaterials/SelectExpendableMaterials.vue'
import PesticideUsageModal from '@/assets/common/Modal/PesticideUsageModal/PesticideUsageModal.vue';
import store from '@/assets/common/store/store';
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';

type WorkRecordPost = {
    kind: "SCHEDULE" | "ACTUAL", // SCHEDULE or ACTUAL
    work_date: string, // 作業日
    work_item_id: string,
    planting_id: string | null, // 作付ID
    agri_field_id: string,
    work_unit_id: string|null, //作業単位ID
    workers: WorkerPost[],
    deletedWorkers: string[], 
    deletedWorker: WorkerDelete[],
    machines: MachinePost[],
    deletedMachines: string[],
    deletedMachine: MachineDelete[],
    chemicals: ChemicalPost[],
    deletedChemicals: { chemicalId: string, warehouseId: string, chemical_updated_time: string | null }[],
    fertilizers: FertilizerPost[],
    deletedFertilizers: { fertilizerId: string, warehouseId: string }[],
    depreciation_materials: DepreciationMaterialPost[],
    deletedDepreciationMaterials: { itemId: string, warehouseId: string }[],
    expendable_materials: ExpendableMaterialPost[],
    deletedExpendableMaterials: { materialId: string, warehouseId: string }[],
    chemicalStockTransactions : {id: string, updated: string | null}[],
    fertilizerStockTransactions : {id: string, updated: string | null}[],
    expendableStockTransactions : {id: string, updated: string | null}[],
    pictureFileIdDetails : {id: string, updated: string | null}[],
    memo: string, // メモ
    updated: Date
}

type WorkerPost = {
    processType: string;
    worker_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    plan_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    actual_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    plan_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    actual_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    plan_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    actual_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    plan_work_time: number, // 作業時間
    actual_work_time: number, // 作業時間
    quantity: number | null, //数量
    memo: string, // メモ
    kind: "SCHEDULE" | "ACTUAL";
}
type WorkerDelete = {
    worker_id: string,
    worker_updated_time: string
}

type MachineDelete = {
    machine_id: string,
    machine_updated_time: string
}

type MachinePost = {
    processType: string;
    machine_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    memo: string, // メモ
}

type ChemicalPost = {
    processType: string;
    warehouse_id: string | null, // 倉庫ID
    chemical_id: string, // 農薬ID
    usage: number | null, // 使用量
    memo: string // メモ
}

type FertilizerPost = {
    processType: string;
    warehouse_id: string | null, // 倉庫ID
    fertilizer_id: string, // 肥料ID
    usage: number, // 使用量
    memo: string // メモ
}

type DepreciationMaterialPost = {
    processType: string;
    warehouse_id: string,
    item_id: string,
    start_worktime: string,
    end_worktime: string,
    rest_time: number,
    work_time: number,
    work_record_depreciation_id : string,
    memo: string
}

type ExpendableMaterialPost = {
    processType: string;
    warehouse_id: string,
    material_id: string,
    expendableMaterialId : string,
    usage: number,
    memo: string
}

type ChemicalUsage = {
    id: string | null;
    cropId: string | null;
    chemicalId: string | null;
    chemicalName: string | null;
    appPartBranchNum : number | null;
    usageCountBranchNum : number | null;
    dilRatioBranchNum : number | null;
    sprayQtyBranchNum : number | null;
    warehouseId: string | null;
    warehouseName: string | null;
    workRecordId: string | null;
    workDate: Date | string | null;
    usageQty: number | null;
    usageUnit: string | null;
    sprayQty: number | null;
    sprayUnit: string | null;
    dilRatio : number | null;
    dilRatioUnit : string | null;
    unitOfMeasure: number;
    disiDiv: number;
    shares : number | null;
    usedDates: Date[];
    editable: boolean;
    isNotSuitable: boolean;
    isExpired: boolean;
    ingSelConditions: SelCondition[];
    amount: number | null;
};

type SelCondition = {
    chemicalId: number;
    isExpired: boolean;
    name: string;
    basicBranchNum: number;
    ingUsageCntBranchNum: number;
    usageCountOrigin: string | null;
    usageCount: number | null;
}

type ChemicalWorkUsage = {
    localId: string | null;
    id: string | null;
    workRecordId: string;
    workDate: Date | string | null;
    appPartBranchNum : number | null;
    usageCountBranchNum : number | null;
    dilRatioBranchNum : number | null;
    sprayQtyBranchNum : number | null;
    unitOfMeasure: number;
    dilRatio : number | null;
    dilRatioUnit : string | null;
    disiDiv: number;
    usageQty: number | null;
    usageUnit: string;
    sprayQty: number | null;
    sprayUnit: string | null;
    shares : number | null;
    ingSelConditions: SelCondition[];
    amount: number | null;
    isNotSuitable: boolean;
    usageCount : number | null;
    usageCountOrigin : string | null;
};

const initialWorkRecord: WorkRecordGet = {
    kind: "SCHEDULE",
    workDate: moment(new Date()).format('YYYY-MM-DD'),
    workItem: {
        id: "",
        name: "",
        isHidden: false,
    },
    workUnit: {
        id:"",
        name: "",
    },
    planting: {
        id: "",
        name: "",
    },
    cropFamicId: null,
    agriField: {
        id: "",
        name: "",
        plantedArea: 0.0,
    },
    workers: [],
    machines: [],
    chemicals: [],
    fertilizers: [],
    depreciationMaterials: [],
    expendableMaterials: [],
    chemicalStockTranscation:[],
    fertilizerStockTranscation:[],
    expendableStockTranscation:[],
    pictureFileIdDetails:[],
    imageId: [""],
    memo: "",
    createdUser: {
        id: "",
        name: "",
        imageId: "",
    },
    created: new Date(),
    updatedUser: {
        id: "",
        name: "",
        imageId: ""
    },
    updated: new Date(),
    isDeletable: true
}

@Component({
    components: {
        SelectPlanting,
        Thumbnail,
        SelectFromPlantings,
        SelectFromAgriFields,
        SelectTime,
        SelectInterval,
        WorkItemSelectModal,
        MachineSelectModal,
        WorkerSelectModal,
        RecordInfo,
        SelectChemicals,
        SelectFertilizers,
        SelectDepreciationMaterials,
        SelectExpendableMaterials,
        EditModal,
        PesticideUsageModal,
        PesticideSelectionModal,
        FertilizerSelectionModal
    }
})
export default class WorkRecordModal extends Vue {
    @Prop({ default: false })
    private readonly isShow!: boolean;
    
    @Prop()
    private id?: string | undefined;

    @Prop()
    private recordDate?: string

    @Prop()
    private harvestRecordId?: string

    @Prop()
    private shippingRecordId?: string

    @Prop()
    private modeType?: string
    @Prop()
    private isWorkRecordPopup?: string

    currentKey: 'dil' | 'spray' | 'usage' | null = null;

    private mode = ''

    private returnTo: string | (string | null)[] = ''

    private images: File[] = []
    private deletedImages: File[] = []
    private baseUrl = '/work_records'
    
    private headerTitle = '作業記録'
    private subTitle = '';
    private workRecord = initialWorkRecord;
    private workerInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private machineInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private materialInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'

    private showSelectFromPlantings = false;
    private showSelectFromAgriFields = false;
    private showSelectTime = false;
    private showSelectInterval = false
    private selectTimeIndex: number | 'all' | undefined;
    private workerOrMachine: 'WORKER' | 'MACHINE' = 'WORKER'
    private unmanagedWarehouseId: string | null = null;

    private targetSelectTime: WorkTimeState | null = null

    private showWorkItemSelect = false
    private showMachineSelect = false
    private showWorkerSelect = false

    private showSelectChemicals = false
    private isShowPesticideSelectionModal = false
    private showFertilizerSelectionModal = false
    private cropItemIds = [] as []
    private showSelectFertilizers = false
    private showSelectDepreciationMaterials = false
    private showSelectExpendableMaterials = false
    private harvestId = ''
    private shippingId = ''
    private modalBaseUrl = ''
    cropFamicName: string | null = null;
    private showEditModal = false
    private workunits = [] as any[];
    private selectedWorkUnitId :string|null=null;
    private workerGoalWorkUnitId :string|null=null;
    private workerGoalWorkUnitName = ''
    showPesticideUsageModal = false;
    cropFamicId: string | null = null;
    caps: Record<number, any[]> = {};
    chemicalData: any[] = [];
    currentChemicalCell: ChemicalUsage | null = null;
    nouyakuNaviTenantId = "";
    private originalWorkRecord = initialWorkRecord ;
    prevCropFamicId : string | null = null;


    // 時刻選択
    private materialRestHour = ''
    private materialRestMinute  = ''
    private minutes = [
        {value: 0, display: '0分'},
        {value: 5, display: '5分'},
        {value: 10, display: '10分'},
        {value: 15, display: '15分'},
        {value: 20, display: '20分'},
        {value: 25, display: '25分'},
        {value: 30, display: '30分'},
        {value: 35, display: '35分'},
        {value: 40, display: '40分'},
        {value: 45, display: '45分'},
        {value: 50, display: '50分'},
        {value: 55, display: '55分'},
    ]

    private hours = [
        {value: 0, display: '0時間'},
        {value: 60, display: '1時間'},
        {value: 120, display: '2時間'},
        {value: 180, display: '3時間'},
        {value: 240, display: '4時間'},
        {value: 300, display: '5時間'},
        {value: 360, display: '6時間'},
        {value: 420, display: '7時間'},
        {value: 480, display: '8時間'},
        {value: 540, display: '9時間'},
        {value: 600, display: '10時間'},
        {value: 660, display: '11時間'},
        {value: 720, display: '12時間'},
        {value: 780, display: '13時間'},
        {value: 840, display: '14時間'},
        {value: 900, display: '15時間'},
        {value: 960, display: '16時間'},
        {value: 1020, display: '17時間'},
        {value: 1080, display: '18時間'},
        {value: 1140, display: '19時間'},
        {value: 1200, display: '20時間'},
        {value: 1260, display: '21時間'},
        {value: 1320, display: '22時間'},
        {value: 1380, display: '23時間'},
    ]

    private originalWorkers = [] as Worker[];

    private originalMachines = [] as Machine[];

    private originalChemicals = [] as ChemicalRecord[];

    private originalFertilizers = [] as FertilizerRecord[];

    private originalDepreciationMaterials = [] as DepreciationMaterialRecord[];

    private originalExpendableMaterials = [] as ExpendableMaterialRecord[];

    private chemicalUnits = [] as any[];

    private fertilizerUnits = [] as any[];
    
    private warehouseChemicals =  [] as WarehouseChemicalWithWPU[];

    get isPesticidePlan() : boolean {
        return this.$store.getters.loginUser.isPesticidePlan;
    }

    get pesticidePlanProducer() : boolean {
        return this.$store.getters.loginUser.pesticidePlanProducer;
    }

    get tenantId(){
        return this.$store.getters.tenantId;
    }

    get isAnyModalOpen(): boolean {
    return (
    this.showSelectFromPlantings ||
    this.showSelectFromAgriFields ||
    this.showSelectTime ||
    this.showSelectInterval ||
    this.showSelectChemicals ||
    this.showSelectFertilizers ||
    this.showSelectDepreciationMaterials ||
    this.showSelectExpendableMaterials ||
    this.showWorkItemSelect ||
    this.showMachineSelect ||
    this.showWorkerSelect ||
    this.showPesticideUsageModal ||
    this.isShowPesticideSelectionModal ||
    this.showFertilizerSelectionModal
    )
    }


    getHour(restTime: number): number {
        return Math.floor(restTime / 60) * 60
    }
    getMinute(restTime: number): number {
        return restTime % 60
    }

    // 作成者/更新者
    private recordInfo: RecordInfoModel | null = null

    private popupElement: HTMLElement | null = null;

    private alertMessage = 'リクエストに失敗しました。\n'
    private isLoading = false;

    created(): void {
        this.returnTo = this.$route.query.return_to
    }
    mounted() {
        this.handleWorkRecordModal();
    }
    @Watch("isShow")
    private handleWorkRecordModal() {
        if(this.modeType) {
            this.mode = this.modeType
        }
        this.unmanagedWarehouseId = ''
        this.callMountedLogic();
        this.getWorkUnits();
        this.getChemicalUnits();
        this.getFertilizerUnits();
        this.getWarehouseChemicals();
    }

    closeModal() {
        if(this.isWorkRecordPopup === 'true' && this.id == null || this.isWorkRecordPopup === 'true' && this.id != null ){
            this.$root.$emit('header-inert', false);
            this.$router.push(`/${this.$route.query.return_to}?date=${this.workRecord.workDate}`).then(() => {return})
        }
        else{
            if (store.getters.isInputChanged) {
                const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
                if (confirm) {
                    store.dispatch("doUpdateIsInputChanged", false);
                    this.mode=''
                    this.$emit('update:isRefresh', true);
                    this.$emit('update:isShow', false);
                    this.cropItemIds= [];
                    this.prevCropFamicId = null
               }
            }else{
            this.mode=''
            this.$emit('update:isShow', false);
            }
            
        }
    }

    // idが空じゃない場合は単体GETする
    async callMountedLogic(): Promise<void> {
        this.cropFamicId = null;
        this.cropFamicName = null;
        this.harvestId = this.harvestRecordId?this.harvestRecordId.toString():'';
        this.shippingId = this.shippingRecordId?this.shippingRecordId.toString():'';
        this.init()
        if (this.recordDate !== null && this.recordDate !== undefined) {
            this.workRecord.workDate = this.recordDate
        } else {
            this.workRecord.workDate = moment(new Date()).format('YYYY-MM-DD')
        }
        if (this.id !== undefined && this.id !== '') {
            const res = toCamel(await this.$apiClient.doRequest('get', '/work_records/' + this.id)) as WorkRecordGet
            this.cropFamicId = res.cropFamicId;
            this.prevCropFamicId =  res.cropFamicId;
            if(res.planting == null) {
                res.planting = {
                    id: null,
                    name: '作付を指定しない',
                    crop: {
                        id: '',
                        name: '',
                        phonetic: ''
                    }
                }
            }
                   const workerRecord : Worker[] = res.workers.map((item: any) => {
                    return {
                        worker: {
                            id: item.worker.id, 
                            name: item.worker.name 
                        },
                        startWorktime: item.kind === "SCHEDULE"? item.planStartWorktime:item.actualStartWorktime ,
                        planStartWorktime: item.planStartWorktime,
                        actualStartWorktime: item.actualStartWorktime,
                        endWorktime:  item.kind === "SCHEDULE"? item.planEndWorktime : item.actualEndWorktime,
                        planEndWorktime: item.planEndWorktime, 
                        actualEndWorktime: item.actualEndWorktime,
                        restTime: item.kind === "SCHEDULE" ? item.planRestTime : item.actualRestTime,
                        planRestTime: item.planRestTime, 
                        actualRestTime: item.actualRestTime,
                        workTime: item.kind === "SCHEDULE" ? item.planWorkTime : item.actualWorkTime ,
                        planWorkTime: item.planWorkTime, 
                        actualWorkTime: item.actualWorkTime,
                        quantity:item.quantity,
                        memo: item.memo,
                        kind: item.kind,
                        workerUpdatedTime : item.workerUpdatedTime
                    };
                });
                    const workRecordData = { ...res };
                    workRecordData.workers = workerRecord;
                    this.workRecord = workRecordData;
                    this.getChemAppParts();
                    this.getChemicalData();
                    this.originalWorkRecord = { ...workRecordData };
                    this.originalWorkers = this.workRecord.workers.map(w => ({...w}))
                    this.originalMachines = this.workRecord.machines.map(m => ({...m}))
                    // this.workRecord.chemicals = this.workRecord.chemicals.map(c => ({...c,id: c.chemicalId}));
                    this.workRecord.chemicals = this.workRecord.chemicals.map(c => ({
                        ...c,
                        id: c.chemicalId,
                        prevUsageUnit: c.usageUnit
                    }));
                    this.workRecord.chemicals.sort((a, b) => {
                        if (a.warehouseName === "未管理" || !a.warehouseName) return 1;
                        if (b.warehouseName === "未管理" || !b.warehouseName) return -1;

                        const warehouseCompare = a.warehouseName.localeCompare(b.warehouseName, "ja");
                        if (warehouseCompare !== 0) return warehouseCompare;

                        const aName = a.chemicalDisplayName || a.name || "";
                        const bName = b.chemicalDisplayName || b.name || "";
                        return aName.localeCompare(bName, "ja");
                    });
                    this.originalChemicals = this.workRecord.chemicals.map(c => ({...c}))
                    // this.workRecord.fertilizers = this.workRecord.fertilizers.map(f => ({...f,id: f.fertilizerId}));
                    this.workRecord.fertilizers = this.workRecord.fertilizers.map(f => ({
                        ...f,
                        id: f.fertilizerId,
                        prevUsageUnit: f.usageUnit
                    }));
                    this.workRecord.fertilizers.sort((a, b) => {
                        if (a.warehouseName === "未管理" || !a.warehouseName) return 1;
                        if (b.warehouseName === "未管理" || !b.warehouseName) return -1;
            
                        const warehouseCompare = a.warehouseName.localeCompare(b.warehouseName, "ja");
                        if (warehouseCompare !== 0) return warehouseCompare;
            
                        const aName = a.fertilizerName || "";
                        const bName = b.fertilizerName || "";
                        return aName.localeCompare(bName, "ja");
                    });
                    this.originalFertilizers = this.workRecord.fertilizers.map(f => ({...f}))
                    this.originalDepreciationMaterials = this.workRecord.depreciationMaterials.map(d => ({...d}))
                    this.originalExpendableMaterials = this.workRecord.expendableMaterials.map(e => ({...e}))
            // this.mode = 'edit'
            let workerInputTypeIsTimePoint
            if(this.workRecord.workers.length) {
                workerInputTypeIsTimePoint = this.workRecord.workers
                .map(w => 
                    this.workRecord.kind === "SCHEDULE" ?  w.planStartWorktime !== null && w.planEndWorktime !== null && w.planRestTime !== null :
                    w.actualStartWorktime !== null && w.actualEndWorktime !==null && w.actualRestTime!==null
                    ).reduce((res, b) => 
                    res && b
                    )
                }
            this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
            let machineInputTypeIsTimePoint
            if(this.workRecord.machines.length) {
                machineInputTypeIsTimePoint = this.workRecord.machines
                    .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                    .reduce((res, b) => res && b)
            }
            this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'

            this.workRecord.imageId.forEach(imi => {
                this.$apiClient.doRequest('get', `${this.baseUrl}/${this.id}/images/${imi}/`).then(res => {
                    const file = toCamel(res) as File
                    this.images.push(file)
                })
            })
            this.recordInfo = {
                createdUser: this.workRecord.createdUser,
                created: this.workRecord.created.toString(),
                updatedUser: this.workRecord.updatedUser,
                updated: this.workRecord.updated.toString()
            }
            if(this.workRecord.workUnit!=null){
                this.workerGoalWorkUnitName = this.workRecord.workUnit.name
                this.selectedWorkUnitId = this.workRecord.workUnit.id
            }
        }
    }

    initializeChemicals(chemicals: any[]) {
        const unmanaged = chemicals.find(c => c.warehouseName === '未管理');
        this.unmanagedWarehouseId = unmanaged ? unmanaged.warehouseId : null;
        return chemicals.map(c => ({
            id: c.id,
            warehouseId: c.warehouseName === '未管理' ? null : c.warehouseId,
        }));
    }

    initializeFertilizers(fertilizers: any[]) {
        const unmanaged = fertilizers.find(c => c.warehouseName === '未管理');
        const payload = fertilizers.map(f => ({
            id: f.id,
            warehouseId: f.warehouseName === '未管理' ? null : f.warehouseId,
        }));
        return payload
    }

    handleUnitChange(idx: number, type: 'chemical' | 'fertilizer') {
        let item;
        if (type === 'chemical') {
            item = this.workRecord.chemicals[idx];
        } else if (type === 'fertilizer') {
            item = this.workRecord.fertilizers[idx];
        }
        this.inputChanged();
        if (!item) return;
        if (!item.prevUsageUnit) {
            item.prevUsageUnit = item.usageUnit;
            return;
        }
        if (item.prevUsageUnit === item.usageUnit) return;
        const oldUnit = item.prevUsageUnit;
        const newUnit = item.usageUnit;
        if(type === 'chemical'){
            const newValue = this.convertUnitChem(Number(item.usage), oldUnit, newUnit);
            item.usage = newValue;
        } else if (type === 'fertilizer') {
            const newValue = this.convertUnitFert(Number(item.usage), oldUnit, newUnit);
            item.usage = newValue;
        }
        item.prevUsageUnit = newUnit;
    }

    private init() {
        this.originalWorkers = []
        this.originalMachines = []
        this.originalChemicals = []
        this.originalFertilizers = []
        this.originalDepreciationMaterials = []
        this.originalExpendableMaterials = []
        this.workRecord = {
            kind: "SCHEDULE",
            workDate: moment(new Date()).format('YYYY-MM-DD'),
            workItem: {
                id: "",
                name: "",
                isHidden: false,
            },
            workUnit: {
                id:"",
                name:"",
            },
            planting: {
                id: "",
                name: "",
            },
            cropFamicId: null,
            agriField: {
                id: "",
                name: "",
                plantedArea: 0.0,
            },
            workers: [],
            machines: [],
            chemicals: [],
            fertilizers: [],
            depreciationMaterials: [],
            expendableMaterials: [],
            chemicalStockTranscation:[],
            fertilizerStockTranscation:[],
            expendableStockTranscation:[],
            pictureFileIdDetails:[],
            imageId: [""],
            memo: "",
            createdUser: {
                id: "",
                name: "",
                imageId: "",
            },
            created: new Date(),
            updatedUser: {
                id: "",
                name: "",
                imageId: ""
            },
            updated: new Date(),
            isDeletable: true
        }
        if(this.mode =='edit'){
            this.headerTitle = '作業記録編集'
        }else{
            this.headerTitle = '作業記録新規作成'
            this.subTitle = this.modeType === 'copy' ? '（複製）': '';
            this.harvestId = "";
            this.shippingId = "";
            this.harvestRecordId = "";
            this.shippingRecordId = "";
        }
        this.images = []
        this.deletedImages = []
        this.workerInputType = 'TIME_POINT'
        this.machineInputType = 'TIME_POINT'
        this.selectedWorkUnitId = null
        this.workerGoalWorkUnitName = ''
        this.cropFamicId = null;
        this.prevCropFamicId = "";
        this.cropFamicName = null;
    }

    private updateDate() {
        const selectTimeRef: any = this.$refs.selectTime
        selectTimeRef.update()
        this.inputChanged()
    }

    // 分を時間表記に変更する
    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '0時間0分';
    }

    // モーダル操作系
    private openSelectFrom(str: string) {
        if (str === 'PLANTINGS') {
            this.showSelectFromPlantings = true
        } else {
            this.showSelectFromAgriFields = true
        }
        this.inputChanged()
    }

    private openWorkerSelectTime(idx: number | 'all') {
        const isTime = this.workerInputType === 'TIME_POINT'
        if (isTime) {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const worker = this.workRecord.workers[idx]
            // 既に作業時間（時刻の時は＋開始・終了時間）が入っているときはそれを初期値とする
            if(worker.workTime > 0 && (!isTime || (worker.startWorktime && worker.endWorktime))) {
                this.targetSelectTime = {
                    startWorktime: worker.startWorktime,
                    endWorktime: worker.endWorktime,
                    restTime: worker.restTime,
                    workTime: worker.workTime,
                }
            }
        }
        this.workerOrMachine = 'WORKER'
        this.inputChanged()
    }

    private openMachineSelectTime(idx: number | 'all') {
        if (this.machineInputType === 'TIME_POINT') {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const machine = this.workRecord.machines[idx]
            // 既に作業時間が入っているときはそれを初期値とする
            if(machine.workTime > 0) {
                this.targetSelectTime = {
                    startWorktime: machine.startWorktime,
                    endWorktime: machine.endWorktime,
                    restTime: machine.restTime,
                    workTime: machine.workTime
                } as WorkTimeState
            }
        }
        this.workerOrMachine = 'MACHINE'
        this.inputChanged()
    }

    private initializeMachines(machines: Machine[]) {
        return machines.map(m => ({
            ...m.machine,
            isHidden: false,
        }))
    }

    private initializeWokers(workers: Worker[]) {
        return workers.map(w => ({
            ...w.worker,
            isHidden: false,
        }))
    }

    private commitWorkItem(value: Item) {
        this.workRecord.workItem = value
        this.workRecord.workers.forEach(worker => {worker.quantity = null;});        
        this.getWorkerGoalWorkUnits()
    }

    private updateWorkItem(value: Item) {
        if (value && this.workRecord.workItem.id) {
            this.workRecord.workItem = value
        }
    }

    private commitWorkers(value: { id: string, name: string }[]) {
        const existingWorker = this.workRecord.workers.filter(w => value.find(v => v.id === w.worker.id) !== undefined)
        const newWorker: Worker[] = value
            .filter(v => this.workRecord.workers.find(w => w.worker.id === v.id) === undefined)
            .map(v => ({
                worker: v,
                startWorktime: null,
                planStartWorktime: null,
                actualStartWorktime: null,
                endWorktime: null,
                planEndWorktime: null,
                actualEndWorktime: null,
                restTime: null,
                planRestTime: null,
                actualRestTime: null,
                workTime: 0,
                planWorkTime: 0,
                actualWorkTime: 0,
                quantity:null,
                memo: "",
                kind :"SCHEDULE",
                workerUpdatedTime :""
            }))
        this.workRecord.workers = [...existingWorker, ...newWorker]
    }

    private commitMachines(value: { id: string, name: string }[]) {
        const newMachines: Machine[] = value.map(v => {
            const existingMachine = this.workRecord.machines.find(m => m.machine.id === v.id)
            return {
                machine: v,
                startWorktime: existingMachine ? existingMachine.startWorktime : null,
                endWorktime: existingMachine ? existingMachine.endWorktime : null,
                restTime: existingMachine ? existingMachine.restTime : null,
                workTime: existingMachine ? existingMachine.workTime : 0,
                memo: existingMachine ? existingMachine.memo : "",
                machineUpdatedTime : existingMachine ? existingMachine.machineUpdatedTime : ""
            }
        })
        this.workRecord.machines = [...newMachines]
    }

    private updateMachine(value: Item) {
        this.workRecord.machines.forEach(item => {
            if (value && item.machine.id === value.id) {
                item.machine = value
            }
        })
    }

    private commitTime(value: WorkTimeState) {
        if (this.workerOrMachine === 'WORKER') {
            if (typeof this.selectTimeIndex === 'number') {
                const worker = this.workRecord.workers[this.selectTimeIndex]
                this.workRecord.workers[this.selectTimeIndex] = { ...worker, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.workRecord.workers = this.workRecord.workers.map(w => ({ ...w, ...value }))
            }
        } else if (this.workerOrMachine === 'MACHINE') {
            if (typeof this.selectTimeIndex === 'number') {
                const machine = this.workRecord.machines[this.selectTimeIndex]
                this.workRecord.machines[this.selectTimeIndex] = { ...machine, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.workRecord.machines = this.workRecord.machines.map(m => ({ ...m, ...value }))
            }
        }
        this.targetSelectTime = value
    }

    private commitPlantingAndField(value: SelectAgriFieldAndPlanting) {
        if(this.prevCropFamicId != null && this.prevCropFamicId != ""){
        if (value.planting.cropFamicId !== this.prevCropFamicId && this.prevCropFamicId !== null && this.workRecord.chemicals.length >0 ) {
        const result = window.confirm(
            "品目が変更されたため、散布条件をクリアします。よろしいですか？"
        );
        if (!result) {
            return false;
        }
         if (this.prevCropFamicId === value.planting.cropFamicId) return;
            this.workRecord.chemicals.forEach((item: ChemicalRecord) => {
                item.ingSelConditions = [];
                item.appPartBranchNum = null;
                item.usageCountBranchNum = null;
                item.dilRatioBranchNum = null;
                item.sprayQtyBranchNum = null;
            });
        this.cropFamicPesticideCheck(this.workRecord.chemicals , value.planting.cropFamicId);
        }
        }
        const agriField = { id: value.agriField.id, name: value.agriField.name, plantedArea: value.agriField.plantedArea }
        this.workRecord = { ...this.workRecord, planting: value.planting, agriField: agriField }
        this.cropFamicId = value.planting.cropFamicId || null;
        this.prevCropFamicId = value.planting.cropFamicId || null
        this.getWorkerGoalWorkUnits();
        this.getChemAppParts();
        this.getChemicalData();
    }

    private async cropFamicPesticideCheck(value: ChemicalRecord[], cropFamicId: string) {
        if (!cropFamicId) return;
        try {
            const res = await this.$apiClient.doRequest(
            "post",
            `/cultivation_histories/chemical_detail/${null}/${cropFamicId}/${null}`,
            {
                chemicalKeys: value.map(c => ({
                chemicalId: c.id
                }))
            }
            );
            const parsedChemicals = (toCamel(res) as any)
            .chemicals as {
                chemicalId: number;
                memo: string;
                isExpired: boolean;
                isNotSuitable: boolean;
                ingredients: any[];
            }[];

            const parsedMap = new Map<number, any>(
            parsedChemicals.map(p => [Number(p.chemicalId), p])
            );

            this.workRecord.chemicals = this.workRecord.chemicals.map(chem => {
            const key = Number(chem.chemicalId ?? chem.id);
            const matched = parsedMap.get(key);

            if (!matched) {
                return chem; 
            }

            return {
                ...chem,
                isNotSuitable: matched.isNotSuitable ?? false,
                ingredients: matched.ingredients ?? [],
            };
            });

        } catch (error) {
            this.$toasted.error("データの取得に失敗しました。");
        }
    }

   
// this logic will be use in future,so we commented code source , source code has bug   
//     private getShippingItemId(agriField: any, planting: any) {
//     this.$apiClient
//     .doRequest("get", `/admin/chemicals/shipping-items/${planting.id}/${agriField.id}`)
//     .then((res) => {
//       if (res.shippingItems && res.shippingItems.length > 0) {
//         this.shippingItemIds = res.shippingItems.map((item: any) => item.sitemId);
//         this.cropItemIds = res.shippingItems.map((item: any) => item.cropItemId);
//         this.nouyakuNaviTenantId = res.shippingItems[0].tenantId;
//       } else {
//         this.shippingItemIds = [];
//         this.cropItemIds = [];
//         this.nouyakuNaviTenantId = "";
//       }
//     });
// }

    private displayTime(time: string | null) {
        return time ? time.slice(0, 5) : ''
    }

    private changeTime(item: DepreciationMaterialRecord, index: number) {
        const start = moment(item.startWorktime, 'HH:mm')
        const end = moment(item.endWorktime, 'HH:mm')
        const restTime = item.restTime || 0
        let workTime = start.isValid() && end.isValid() ? end.diff(start, 'minutes') : 0;
        workTime = workTime - restTime;
        this.$set(this.workRecord.depreciationMaterials, index, {
            ...this.workRecord.depreciationMaterials[index],
            workTime,
            restTime: restTime
        });
        this.inputChanged();
    }
    
    get materialDisplayTime() {
        return ({ workTime = 0 }: DepreciationMaterialRecord) => {
            const isNegative = workTime < 0;
            const positiveWorkTime = Math.abs(workTime);
            const hours = Math.floor(positiveWorkTime / 60);
            const minutes = positiveWorkTime % 60;
            return `${isNegative ? '-' : ''}${hours}時間${minutes}分`;
        };
    }

    get isInvalidTime() {
        return ({ workTime }: DepreciationMaterialRecord) => {
            return workTime != null && workTime != undefined && workTime < 0 ? true : false;
        };
    }

    updateHr(material: DepreciationMaterialRecord, index: number, hour: number) {
        const minute = material.restTime ? this.getMinute(material.restTime) : 0;
        material.restTime = hour + minute;
        this.changeTime(material, index);
    }
    
    updateMin(material: DepreciationMaterialRecord, index: number, minute: number) {
        const hour = material.restTime ? this.getHour(material.restTime) : 0;
        material.restTime = hour + minute;
        this.changeTime(material, index);
    }

    // ファイル系
    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if (this.$apiClient.isSizeOver(files)) {
            return
        }

        for (const file of files) {
            if (this.$apiClient.isImageFile(file.name)) {
                this.$apiClient.getBase64(file).then((image: any) => {
                    const item = {
                        file: image.file,
                        url: image.base64
                    } as File
                    this.images.push(item)
                }).catch(() => {
                    window.alert('画像ファイルが読み込めませんでした')
                })
            } else {
                window.alert('画像ファイルを選択してください')
            }
        }

        e.target.value = ''
        this.inputChanged()
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if (image.id) {
            this.deletedImages.push(image)
        }
        this.inputChanged()
    }

    private delPlantingAndField() {
        // if (!this.resetPlanting()) {
        //     return;
        // }
        this.workRecord = { ...this.workRecord, planting: { id: '', name: '' }, agriField: { id: '', name: '', plantedArea: 0 } }
        this.inputChanged()
    }

    private validation(): boolean {
        const errmsg: string[] = []

        if (!this.workRecord.workDate) {
            errmsg.push('作業日を選択してください。')
        }

        if (this.workRecord.workItem.id === "") {
            errmsg.push('作業項目を選択してください。')
        }
        if (this.workRecord.planting.id === "" || this.workRecord.agriField.id === "") {
            errmsg.push('作付・圃場を選択してください。')
        }
        if (this.workRecord.workers.length > 0) {
            this.workRecord.workers.forEach(worker => {
                const quantityStr = worker.quantity != null ? worker.quantity.toString().split('.') : null;
                if (worker.quantity != null && (worker.quantity < 0 || (quantityStr != null && quantityStr[0].length > 7) || (quantityStr != null && quantityStr[1]?.length > 2))) {
                  errmsg.push(`数量は0以上の整数部7桁小数部2桁までの数値を入力してください。(作業者：${worker.worker.name})`);
                }
                if (worker.quantity !== null && String(worker.quantity) !== '' && this.selectedWorkUnitId == null) {
                    if (!errmsg.includes("作業単位を選択してください。")) {
                        errmsg.push("作業単位を選択してください。");
                    }
                }
                if (worker.memo && worker.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${worker.memo.length}文字, 作業者：${worker.worker.name}）`)
                }
                if ((worker.quantity == null || String(worker.quantity) == '') && this.selectedWorkUnitId !== null) {
                    errmsg.push(`数量を入力してください。(作業者：${worker.worker.name})`);
                }
            })
        }
        if (this.workRecord.machines.length > 0) {
            this.workRecord.machines.forEach(machine => {
                if (machine.memo && machine.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${machine.memo.length}文字, 機械：${machine.machine.name}）`)
                }
            })
        }
        if (this.workRecord.chemicals && this.workRecord.chemicals.length > 0) {
            this.workRecord.chemicals.forEach(chemical => {
                const displayWarehouseName = !chemical.warehouseName || chemical.warehouseName === "未管理"? "---": chemical.warehouseName;
                const isValidDisiDiv = chemical.disiDiv === 1 || chemical.disiDiv === 2 || chemical.disiDiv === 3;
                if (!isValidDisiDiv) {
                    errmsg.push(`消毒を選択してください。（農薬：${chemical.chemicalDisplayName || chemical.name}／倉庫：${displayWarehouseName}）`);
                }
                if (!chemical.usage) {
                    if (displayWarehouseName != "---") {
                        errmsg.push(`使用量を入力してください。（農薬：${chemical.chemicalDisplayName || chemical.name}／倉庫：${displayWarehouseName}）`);
                    } else {
                        chemical.usage = null;
                    }
                } else {
                    const usageStr = chemical.usage.toString().split('.')
                    if (!(chemical.usage > 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                        errmsg.push(`使用量は0より大きい整数部7桁、小数部2桁までの数値を入力してください。（農薬：${chemical.chemicalDisplayName || chemical.name}／倉庫：${displayWarehouseName}）`);
                    }
                }
                if (!chemical.usageUnit || chemical.usageUnit === '') {
                    errmsg.push(`使用量単位を入力してください。（農薬：${chemical.chemicalDisplayName || chemical.name}／倉庫：${displayWarehouseName}）`);
                }
                if (chemical.amount) {
                    const str = String(chemical.amount).trim();
                    if (str.length > 10) {
                        errmsg.push(`金額は10桁以内で入力してください。（農薬：${chemical.chemicalDisplayName || chemical.name}／倉庫：${displayWarehouseName}）`);
                    }
                }
                if (chemical.memo && chemical.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${chemical.memo.length}文字, 農薬：${chemical.chemicalDisplayName || chemical.name}／倉庫：${displayWarehouseName}）`);
                }
            })
        }
        if (this.workRecord.fertilizers && this.workRecord.fertilizers.length > 0) {
            this.workRecord.fertilizers.forEach(fertilizer => {
                const displayWarehouseName = !fertilizer.warehouseName || fertilizer.warehouseName === "未管理" ? "---" : fertilizer.warehouseName;
                if (!fertilizer.usage) {
                    errmsg.push(`使用量を入力してください。（肥料：${fertilizer.fertilizerName}／倉庫：${displayWarehouseName}）`);
                } else {
                    const usageStr = fertilizer.usage.toString().split('.')
                    if (!(fertilizer.usage > 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                        errmsg.push(`使用量は0より大きい整数部7桁、小数部2桁までの数値を入力してください。（肥料：${fertilizer.fertilizerName}／倉庫：${displayWarehouseName}）`);
                    }
                }
                if (!fertilizer.usageUnit || fertilizer.usageUnit === '') {
                    errmsg.push(`使用量単位を入力してください。（肥料：${fertilizer.fertilizerName}／倉庫：${displayWarehouseName}）`);
                }
                if(fertilizer.memo && fertilizer.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${fertilizer.memo.length}文字, 肥料：${fertilizer.fertilizerName}／倉庫：${displayWarehouseName}）`);
                }
                if (fertilizer.amount) {
                    const str = String(fertilizer.amount).trim();
                    if (str.length > 10) {
                        errmsg.push(`金額は10桁以内で入力してください。肥料：${fertilizer.fertilizerName}／倉庫：${displayWarehouseName}）`);
                    }
                }
            })
        }
        if (this.workRecord.depreciationMaterials.length > 0) {
            this.workRecord.depreciationMaterials.forEach(material => {
                if (material.type == "DEPRECIATION_TIMES") {
                    if (material.workTime == undefined || material.workTime == null || material.workTime == 0) {
                        errmsg.push(`使用時間を入力してください。（資材（減価償却）：${material.displayName}／倉庫：${material.warehouseName}）`);
                    } else if (material.workTime < 0) {
                        errmsg.push(`有効な使用時間を入力してください。（資材（減価償却）：${material.displayName}／倉庫：${material.warehouseName}）`);
                    }
                }

                if(material.memo && material.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${material.memo.length}文字, 資材（減価償却）：${material.displayName}／倉庫：${material.warehouseName}）`);
                }
            })
        }
        if (this.workRecord.expendableMaterials && this.workRecord.expendableMaterials.length > 0) {
            this.workRecord.expendableMaterials.forEach(material => {
                if (!material.usage) {
                    errmsg.push(`使用量を入力してください。（資材（消耗品）：${material.materialName}／倉庫：${material.warehouseName}）`);
                } else {
                    const usageStr = material.usage.toString().split('.')
                    if (!(material.usage > 0) || usageStr[0].length > 7 || (usageStr[1] && usageStr[1].length > 2)) {
                        errmsg.push(`使用量は0より大きい整数部7桁、小数部2桁までの数値を入力してください。（資材（消耗品）：${material.materialName}／倉庫：${material.warehouseName}）`);
                    }
                }
                if (material.memo && material.memo.length > 21844) {
                    errmsg.push(`メモは21844文字以内で入力してください。（現在は${material.memo.length}文字, 資材（消耗品）：${material.materialName}／倉庫：${material.warehouseName}）`);
                }
            })
        }
        if (this.workRecord.memo && this.workRecord.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください。（現在は${this.workRecord.memo.length}文字）`)
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        return true
    }

    buildWorkRecordData(): WorkRecordPost {
        return {
            kind: this.workRecord.kind,
            work_date: this.workRecord.workDate,
            work_item_id: this.workRecord.workItem.id,
            planting_id: this.workRecord.planting.id,
            agri_field_id: this.workRecord.agriField.id,
            work_unit_id:this.selectedWorkUnitId,
            updated:this.workRecord.updated,
            workers: this.workRecord.workers.map(w => {
                const originalWorker = this.originalWorkers.find(orig => orig.worker.id === w.worker.id)
                const workerUpdatedTime = (w.workerUpdatedTime && w.workerUpdatedTime !== "") 
                    ? w.workerUpdatedTime 
                    : originalWorker?.workerUpdatedTime ?? null
                return {
                    worker_id: w.worker.id,
                    start_worktime: w.startWorktime,
                    plan_start_worktime: this.workRecord.kind === "SCHEDULE" ? w.startWorktime : w.planStartWorktime,
                    actual_start_worktime: this.workRecord.kind === "ACTUAL" ? w.startWorktime : null,
                    end_worktime: w.endWorktime,
                    plan_end_worktime: this.workRecord.kind === "SCHEDULE" ? w.endWorktime : w.planEndWorktime,
                    actual_end_worktime: this.workRecord.kind === "ACTUAL" ? w.endWorktime : null,
                    rest_time: w.restTime == null ? 0 : w.restTime,
                    plan_rest_time: this.workRecord.kind === "SCHEDULE" ? (w.restTime == null ? 0 : w.restTime) : (w.planRestTime == null ? 0 : w.planRestTime),
                    actual_rest_time: this.workRecord.kind === "ACTUAL" ? (w.restTime == null ? 0 : w.restTime) : 0,
                    work_time: w.workTime,
                    plan_work_time: this.workRecord.kind === "SCHEDULE" ? (w.workTime == null ? 0 : w.workTime) : (w.planWorkTime == null ? 0 : w.planWorkTime),
                    actual_work_time: this.workRecord.kind === "ACTUAL" ? w.workTime : 0,
                    kind: (this.workRecord.kind === "ACTUAL" && w.planStartWorktime !== null || this.workRecord.kind === "ACTUAL" && w.planStartWorktime == null) ? "ACTUAL" : "SCHEDULE",
                    quantity: w.quantity,
                    memo: w.memo,
                    processType: "NOCHANGE",
                    workerUpdatedTime: workerUpdatedTime
                }
            }),
            deletedWorkers: this.originalWorkers.filter(w => this.workRecord.workers.find(worker => worker.worker.id === w.worker.id) === undefined).map(w => w.worker.id),
            deletedWorker: this.originalWorkers
                .filter(w => this.workRecord.workers.find(worker => worker.worker.id === w.worker.id) === undefined)
                .map(w => ({ worker_id: w.worker.id, worker_updated_time: w.workerUpdatedTime })), 
            machines: this.workRecord.machines.map(w => {
                const originalMachine = this.originalMachines.find(orig => orig.machine.id === w.machine.id)
                const machineUpdatedTime = (w.machineUpdatedTime && w.machineUpdatedTime !== "")
                    ? w.machineUpdatedTime
                    : originalMachine?.machineUpdatedTime ?? null
                return {
                    machine_id: w.machine.id,
                    start_worktime: w.startWorktime,
                    end_worktime: w.endWorktime,
                    rest_time: w.restTime == null ? 0 : w.restTime,
                    work_time: w.workTime,
                    memo: w.memo,
                    processType: "NOCHANGE",
                    machineUpdatedTime: machineUpdatedTime
                }
            }),
            deletedMachines: this.originalMachines.filter(m => this.workRecord.machines.find(machine => machine.machine.id === m.machine.id) === undefined).map(m => m.machine.id),
            deletedMachine: this.originalMachines
                .filter(m => this.workRecord.machines.find(machine => machine.machine.id === m.machine.id)=== undefined)
                .map(m => ({machine_id: m.machine.id,machine_updated_time: m.machineUpdatedTime})),
            chemicals: this.workRecord.chemicals.map(chemical => {
                const originalChemical = this.originalChemicals.find(orig => orig.chemicalId === (chemical.id || chemical.chemicalId) && orig.warehouseId === chemical.warehouseId)
                const chemicalUpdatedTime = (chemical.chemicalUpdatedTime && chemical.chemicalUpdatedTime !== "")
                    ? chemical.chemicalUpdatedTime
                    : originalChemical?.chemicalUpdatedTime ?? null
                const workRecordChemicalId = this.mode === 'edit'
                    ? (chemical.workRecordChemicalId && chemical.workRecordChemicalId !== "")
                        ? chemical.workRecordChemicalId
                        : originalChemical?.workRecordChemicalId ?? null
                    : ""
                
                return {
                    chemical_id: chemical.id || chemical.chemicalId,
                    work_record_chemical_id: workRecordChemicalId,
                    warehouse_id: this.mode === "copy" ? chemical.warehouseName === "未管理" ? null : chemical.warehouseId : chemical.warehouseId,
                    appPartBranchNum: chemical.appPartBranchNum,
                    usageCountBranchNum: chemical.usageCountBranchNum,
                    dilRatioBranchNum: chemical.dilRatioBranchNum,
                    sprayQtyBranchNum: chemical.sprayQtyBranchNum,
                    usage: chemical.usage,
                    usageUnit: chemical.usageUnit,
                    sprayQty: chemical.sprayQty,
                    sprayUnit: chemical.sprayUnit,
                    dilRatio: chemical.dilRatio,
                    dilRatioUnit: chemical.dilRatioUnit,
                    unitOfMeasure: chemical.unitOfMeasure,
                    disiDiv: chemical.disiDiv,
                    shares: chemical.shares,
                    memo: chemical.memo,
                    processType: "NOCHANGE",
                    amount: chemical.amount || 0,
                    ingSelConditions: chemical.ingSelConditions || [],
                    chemicalUpdatedTime: chemicalUpdatedTime
                }
            }),
            deletedChemicals: this.originalChemicals
                .filter(e => !this.workRecord.chemicals.some(chemical => chemical.id === e.chemicalId && chemical.warehouseId === e.warehouseId))
                .map(e => ({ chemicalId: e.chemicalId, warehouseId: e.warehouseId, chemical_updated_time:e.chemicalUpdatedTime, workRecordChemicalId:e.workRecordChemicalId })),
            fertilizers: this.workRecord.fertilizers.map(fertilizer => {
                const originalFertilizer = this.originalFertilizers.find(orig => orig.fertilizerId === (fertilizer.fertilizerId || fertilizer.id) && orig.warehouseId === fertilizer.warehouseId)
                const fertilizerUpdatedTime = (fertilizer.fertilizerUpdatedTime && fertilizer.fertilizerUpdatedTime !== "")
                    ? fertilizer.fertilizerUpdatedTime
                    : originalFertilizer?.fertilizerUpdatedTime ?? null
                return {
                    fertilizer_id: fertilizer.fertilizerId || fertilizer.id,
                    warehouse_id: this.mode === "copy" ? fertilizer.warehouseName === "未管理" ? null : fertilizer.warehouseId : fertilizer.warehouseId,
                    work_record_fertilizer_id: this.mode === 'edit'
                        ? (fertilizer.workRecordFertilizerId && fertilizer.workRecordFertilizerId !== "")
                            ? fertilizer.workRecordFertilizerId
                            : originalFertilizer?.workRecordFertilizerId ?? null
                        : "",
                    usage: fertilizer.usage,
                    memo: fertilizer.memo,
                    usageUnit: fertilizer.usageUnit,
                    unitOfMeasure: fertilizer.unitOfMeasure,
                    processType: "NOCHANGE",
                    amount: fertilizer.amount || 0,
                    fertilizerUpdatedTime: fertilizerUpdatedTime
                }
            }),
            deletedFertilizers: this.originalFertilizers
                .filter(e => !this.workRecord.fertilizers.some(fertilizer => fertilizer.id === e.fertilizerId && fertilizer.warehouseId === e.warehouseId))
                .map(e => ({ fertilizerId: e.fertilizerId, warehouseId: e.warehouseId, fertilizer_updated_time:e.fertilizerUpdatedTime,workRecordFertilizerId: e.workRecordFertilizerId })),
            depreciation_materials: this.workRecord.depreciationMaterials.map(material => {
                const originalDepreciation = this.originalDepreciationMaterials.find(orig => orig.itemId === material.itemId && orig.warehouseId === material.warehouseId)
                const depreciationMaterialUpdatedTime = (material.depreciationMaterialUpdatedTime && material.depreciationMaterialUpdatedTime !== "")
                    ? material.depreciationMaterialUpdatedTime
                    : originalDepreciation?.depreciationMaterialUpdatedTime ?? null
                return {
                    item_id: material.itemId,
                    warehouse_id: material.warehouseId,
                    start_worktime: material.startWorktime,
                    end_worktime: material.endWorktime,
                    rest_time: material.restTime ? material.restTime : 0,
                    work_time: material.workTime,
                    work_record_depreciation_id: this.mode === 'edit' ? (originalDepreciation?.materialWorkingId ? originalDepreciation.materialWorkingId : "") : "",
                    memo: material.memo,
                    processType: "NOCHANGE",
                    depreciationMaterialUpdatedTime: depreciationMaterialUpdatedTime
                }
            }),
            deletedDepreciationMaterials: this.originalDepreciationMaterials
                .filter(e => !this.workRecord.depreciationMaterials.some(material => material.itemId === e.itemId && material.warehouseId === e.warehouseId))
                .map(e => ({ itemId: e.itemId, warehouseId: e.warehouseId, depreciation_updated_time:e.depreciationMaterialUpdatedTime, work_record_depreciation_id:e.materialWorkingId })),

            expendable_materials: this.workRecord.expendableMaterials.map(material => {
                const originalExpendable = this.originalExpendableMaterials.find(orig => orig.materialId === material.materialId && orig.warehouseId === material.warehouseId)
                const expendableMaterialUpdatedTime = (material.expendableMaterialUpdatedTime && material.expendableMaterialUpdatedTime !== "")
                    ? material.expendableMaterialUpdatedTime
                    : originalExpendable?.expendableMaterialUpdatedTime ?? null
                return {
                    material_id: material.materialId,
                    warehouse_id: material.warehouseId,
                    expendableMaterialId: this.mode === 'edit' ? ( originalExpendable?.expendableMaterialId ?  originalExpendable?.expendableMaterialId :  "" ) : "",
                    usage: material.usage,
                    memo: material.memo,
                    processType: "NOCHANGE",
                    expendableMaterialUpdatedTime: expendableMaterialUpdatedTime
                }
            }),
            deletedExpendableMaterials: this.originalExpendableMaterials
                .filter(e => !this.workRecord.expendableMaterials.some(material => material.materialId === e.materialId && material.warehouseId === e.warehouseId))
                .map(e => ({ materialId: e.materialId, warehouseId: e.warehouseId, expendable_updated_time:e.expendableMaterialUpdatedTime, expendableMaterialId:e.expendableMaterialId })),
            memo: this.workRecord.memo,
            chemicalStockTransactions: this.workRecord.chemicalStockTranscation.map(chemical=>({
                id:chemical.id,
                updated: chemical.updated
            })),
            fertilizerStockTransactions: this.workRecord.fertilizerStockTranscation.map(fertilizer=>({
                id:fertilizer.id,
                updated: fertilizer.updated
            })),
            expendableStockTransactions: this.workRecord.expendableStockTranscation.map(expenable=>({
                id:expenable.id,
                updated: expenable.updated
            })),
            pictureFileIdDetails:this.workRecord.pictureFileIdDetails.map(pic=>({
                id:pic.id,
                updated:pic.updated
            }))
        };
    }

    async saveRecord(isNotRefresh: boolean | null): Promise<boolean> {
        if (!this.validation()) {
            return false
        }
        let res = false;
        this.isLoading = true;
        if (this.pesticidePlanProducer && this.workRecord.planting.id != null && !this.workRecord.agriField.id != null && this.workRecord.kind === "ACTUAL") {
            res = await this.$apiClient.doRequest('get', `/work_records/has_cv_history/${this.workRecord.planting.id}/${this.workRecord.agriField.id}`);
            if (res) {
                if (!window.confirm("編集した内容は、栽培履歴にも更新されます。\n内容を上書きして保存します。よろしいですか？")) {
                    this.isLoading = false;
                    return false;
                }
            }
        }
        let data = this.buildWorkRecordData();
        let property: {
            method: 'post' | 'put',
            url: string,
            message: string,
        } = {
            method: 'post',
            url: this.baseUrl,
            message: '保存しました。'
        }
        if (this.mode === 'edit') {
            data = this.updateProcessType(data);
            if(!res){
                if (!window.confirm("内容を上書きして保存します。よろしいですか。")) {
                this.isLoading = false;
                return false;
                }
            }
           
            property = {
                method: 'put',
                url: `${this.baseUrl}/${this.id}`,
                message: '変更を保存しました。'
            }
        }

        return new Promise((resolve) => {
        this.$apiClient.doRequest(property.method, property.url, data)
            .then(res => {
                if (res.message) {
                    window.alert(this.alertMessage + res.message);
                    this.$toasted.error('変更に失敗しました。');
                    resolve(false);
                    return;
                }
                const promise: Promise<{ id: string }>[] = []
                this.images.forEach(im => {
                    if (im.file !== null && im.file !== undefined) {
                        promise.push(this.$apiClient.fileUpload(`${this.baseUrl}/${res.id}/images/`, im.file))
                    }
                })
                this.deletedImages.forEach(im => {
                    promise.push(this.$apiClient.doRequest('delete', `${this.baseUrl}/${res.id}/images/${im.id}/`))
                })
                Promise.all(promise).then(() => {
                    this.$toasted.success(property.message)
                    // 添付ファイル情報は複製対象外のため、無条件で初期化
                    this.workRecord.imageId = [""]
                    this.images = []
                    this.deletedImages = []

                    if(isNotRefresh !== true) {
                        this.$emit('update:isRefresh', true);
                        this.$store.dispatch('doUpdateIsInputChanged', false);
                        this.isLoading = false;
                        this.closeModal();
                        this.init()
                    }
                    resolve(true);
                }).catch(() => {
                    this.$toasted.error('写真の保存に失敗しました。')
                    resolve(false);
                })
            }).catch(() => {
                this.$toasted.error('保存に失敗しました。')
                resolve(false);
            }).finally(() => {
                this.isLoading = false;
            })
        });
        
    }

    async saveAndCopyRecord() :Promise<void> {
        const successRequest = await this.saveRecord(true)
        if(successRequest) {
            this.mode = ''
            this.recordInfo = null
        }
    }

    deleteRecord(): void {
        const confirm = window.confirm('削除しますか？')
        const data = this.buildWorkRecordData();
        if(confirm) {
            this.isLoading = true;
            this.$apiClient.doRequest('delete', `${this.baseUrl}/${this.id}`,data)
                .then((res) => {
                    if (res.message) {
                        window.alert(this.alertMessage + res.message);
                        this.$toasted.error('変更に失敗しました。');
                        this.isLoading = false;
                        return;
                    }
                    this.$toasted.success('削除しました。')
                    this.$emit('update:isRefresh', true);
                    this.$store.dispatch('doUpdateIsInputChanged', false);
                    this.isLoading = false;
                    this.closeModal();
                })
                .catch(() => {
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.$toasted.success('削除がキャンセルされました。')
        }
    }

    deleteWorker(index: number,workerId:string): void {
        this.workRecord.workers.splice(index, 1)
        this.inputChanged()
    }

    deleteMachine(index: number): void {
        this.workRecord.machines.splice(index, 1)
        this.inputChanged()
    }

    private async commitChemicals(value: ChemicalRecord[]) {
        let parsedChemicals: {
            chemicalId: number;
            memo: string;
            isExpired: boolean;
            isNotSuitable: boolean;
            ingredients: any[];
        }[] = [];
        if (this.cropFamicId) {
            try {
                const res = await this.$apiClient.doRequest('post', `/cultivation_histories/chemical_detail/${null}/${this.cropFamicId}/${null}`,
                    {
                        chemicalKeys: value.map(c => ({
                            chemicalId: c.id,
                        }))
                    }
                );
                parsedChemicals = (toCamel(res) as any).chemicals;
            } catch {
                this.$toasted.error('データの取得に失敗しました。');
            }
        }
        this.inputChanged();
        const newChemicals: ChemicalRecord[] = value.map(item => {
            const normalizedItemWarehouseId = item.warehouseId ?? this.unmanagedWarehouseId;
            const existingChemicals = this.workRecord.chemicals.find(chemical => {
                const chemId = chemical.chemicalId ?? chemical.id;
                const normalizedExistingWarehouseId = chemical.warehouseId ?? this.unmanagedWarehouseId;
                return chemId === item.id && normalizedExistingWarehouseId === normalizedItemWarehouseId;
            });
            const match = parsedChemicals.find(pc => pc.chemicalId === Number(item.id));
            const units = this.filteredChemicalUnits(Number(item.id) || Number(item.chemicalId), item.warehouseId);
            const currentDisiDiv = existingChemicals?.disiDiv;
            const normalizedDisiDiv = currentDisiDiv === 1 || currentDisiDiv === 2 || currentDisiDiv === 3 ? currentDisiDiv : 2;
            return {
                id: item.id,
                name: existingChemicals?.chemicalDisplayName ? existingChemicals.chemicalDisplayName  : (existingChemicals?.name ?? item.name),
                warehouseId: item.warehouseId,
                warehouseName: normalizedItemWarehouseId === this.unmanagedWarehouseId ? '未管理' : item.warehouseName,
                usage: existingChemicals?.usage,
                usageUnit: existingChemicals?.usageUnit ? existingChemicals.usageUnit : item.unitName || (units[0]?.name || 'kg'),
                prevUsageUnit: existingChemicals?.usageUnit ? existingChemicals.usageUnit : item.unitName || (units[0]?.name || 'kg'),
                sprayQty: existingChemicals?.sprayQty ? existingChemicals.sprayQty : null,
                sprayQtyBranchNum: existingChemicals?.sprayQtyBranchNum ? existingChemicals.sprayQtyBranchNum : null,
                sprayUnit: existingChemicals?.sprayUnit ? existingChemicals.sprayUnit : "L",
                dilRatio: existingChemicals?.dilRatio ? existingChemicals.dilRatio : null,
                dilRatioBranchNum: existingChemicals?.dilRatioBranchNum ? existingChemicals.dilRatioBranchNum : null,
                dilRatioUnit: existingChemicals?.dilRatioUnit ? existingChemicals.dilRatioUnit : "倍",
                appPartBranchNum: existingChemicals?.appPartBranchNum ? existingChemicals.appPartBranchNum : null,
                usageCountBranchNum: existingChemicals?.usageCountBranchNum ? existingChemicals.usageCountBranchNum : null,
                disiDiv: normalizedDisiDiv,
                shares: existingChemicals?.shares ? existingChemicals.shares : null,
                unitOfMeasure: existingChemicals?.unitOfMeasure ? existingChemicals.unitOfMeasure : 0,
                addSettings: existingChemicals?.addSettings ? existingChemicals.addSettings : false,
                memo: existingChemicals?.memo,
                usageCount: existingChemicals?.usageCount ? existingChemicals.usageCount : null,
                usageCountOrigin: existingChemicals?.usageCountOrigin ? existingChemicals.usageCountOrigin : null,
                amount: existingChemicals?.amount ? existingChemicals.amount : null,
                workRecordChemicalId: existingChemicals?.workRecordChemicalId ? existingChemicals.workRecordChemicalId : null,
                ingSelConditions: existingChemicals?.ingSelConditions ? existingChemicals.ingSelConditions : [],
                isNotSuitable: existingChemicals?.isNotSuitable || match?.isNotSuitable || false,
                isExpired: existingChemicals?.isExpired ?? item.isExpired ?? false,
                ingredients: existingChemicals?.ingredients || match?.ingredients || [],
                chemicalUpdatedTime: existingChemicals?.chemicalUpdatedTime ? existingChemicals?.chemicalUpdatedTime : null
            }
        }) as ChemicalRecord[]
        newChemicals.sort((a, b) => {
            if (!a.warehouseName) return 1;
            if (!b.warehouseName) return -1;
        
            const warehouseCompare = a.warehouseName.localeCompare(b.warehouseName, "ja");
            if (warehouseCompare !== 0) {
                return warehouseCompare;
            }
        
            return a.name.localeCompare(b.name, "ja");
        });
        this.workRecord.chemicals = newChemicals
    }

    private deleteChemical(index: number): void {
        this.workRecord.chemicals.splice(index, 1)
        this.inputChanged()
    }

    private commitFertilizers(value: FertilizerRecord[]) {
        this.inputChanged();
        const newFertilizers: FertilizerRecord[] = value.map(item => {
            const normalizedItemWarehouseId = item.warehouseId ?? this.unmanagedWarehouseId;
            let existingFertilizers = this.workRecord.fertilizers.find(fertilizer => {
                const fertId = fertilizer.fertilizerId != null ? fertilizer.fertilizerId : fertilizer.id;
                const normalizedExistingWarehouseId = fertilizer.warehouseId ?? this.unmanagedWarehouseId;
                return fertId === item.id && normalizedExistingWarehouseId === normalizedItemWarehouseId;
            });
    
            if (!existingFertilizers && !item.warehouseId) {
                existingFertilizers = this.workRecord.fertilizers.find(fertilizer => {
                    const fertId = fertilizer.fertilizerId != null ? fertilizer.fertilizerId : fertilizer.id;
                    return fertId === item.id && fertilizer.warehouseName === '未管理';
                });
            }
            return {
                id: item.id,
                fertilizerName: item.name,
                fertilizerUnitName: item.unitName || 'kg',
                warehouseId: item.warehouseId,
                warehouseName: normalizedItemWarehouseId === this.unmanagedWarehouseId ? '未管理' : item.warehouseName,
                usage: existingFertilizers?.usage,
                memo: existingFertilizers?.memo,
                usageUnit: existingFertilizers?.usageUnit ? existingFertilizers.usageUnit : item.unitName || "kg",
                prevUsageUnit: existingFertilizers?.usageUnit ? existingFertilizers.usageUnit : item.unitName || "kg",
                unitOfMeasure: existingFertilizers?.unitOfMeasure ? existingFertilizers.unitOfMeasure : 0 ,
                chemRetio : existingFertilizers?.chemRetio ?  existingFertilizers?.chemRetio : item.chemRetio,
                amount: existingFertilizers?.amount ? existingFertilizers.amount : null,
                workRecordFertilizerId: existingFertilizers?.workRecordFertilizerId ? existingFertilizers.workRecordFertilizerId : null,
                fertilizerUpdatedTime: existingFertilizers?.fertilizerUpdatedTime ? existingFertilizers?.fertilizerUpdatedTime : null
            }
        }) as FertilizerRecord[]
        newFertilizers.sort((a, b) => {
            if (!a.warehouseName) return 1;
            if (!b.warehouseName) return -1;
            const warehouseCompare = a.warehouseName.localeCompare(b.warehouseName, "ja");
            if (warehouseCompare !== 0) {
                return warehouseCompare;
            }
            return a.fertilizerName.localeCompare(b.fertilizerName, "ja");
        });
        this.workRecord.fertilizers = newFertilizers
    }

    private deleteFertilizer(index: number): void {
        this.workRecord.fertilizers.splice(index, 1)
        this.inputChanged()
    }

    private commitExpendableMaterials(value: ExpendableMaterialRecord[]) {
        const newExpendableMaterials: ExpendableMaterialRecord[] = value.map(item => {
            const existingExpendableMaterials = this.workRecord.expendableMaterials.find(material => material.warehouseId === item.warehouseId && material.materialId === item.materialId)
            return {
                ...item,
                usage: existingExpendableMaterials?.usage,
                memo: existingExpendableMaterials?.memo
            }
        }) as ExpendableMaterialRecord[]
        this.workRecord.expendableMaterials = newExpendableMaterials
    }

    private deleteExpendableMaterial(index: number): void {
        this.workRecord.expendableMaterials.splice(index, 1)
        this.inputChanged()
    }

    private commitDepreciationMaterials(value: DepreciationMaterialRecord[]) {
        const newDepreciationMaterials: DepreciationMaterialRecord[] = value.map(item => {
            const existingDepreciationMaterials = this.workRecord.depreciationMaterials.find(material => material.warehouseId === item.warehouseId && material.itemId === item.itemId)
            return {
                ...item,
                memo: existingDepreciationMaterials?.memo || null,
                startWorktime: existingDepreciationMaterials?.startWorktime || null,
                endWorktime: existingDepreciationMaterials?.endWorktime || null,
                restTime: existingDepreciationMaterials?.restTime || 0,
                workTime: existingDepreciationMaterials?.workTime,
            }
        }) as DepreciationMaterialRecord[]
        this.workRecord.depreciationMaterials = newDepreciationMaterials
    }

    private deleteDepreciationMaterials(index: number): void {
        this.workRecord.depreciationMaterials.splice(index, 1)
        this.inputChanged()
    }

    @Emit('inputChanged')
    private inputChanged() {
        if (store.getters.isInputChanged == false) {
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    async changePlan(){
        const workerKind = this.workRecord.workers.find(item => item.kind=="ACTUAL")
        if(this.workRecord.kind === "ACTUAL" && workerKind){
            const result = window.confirm('作業者の実績時間が削除されますが、予定に変更しますか？');
            if(!result){
              this.revertRecord()
            }
            else{
            const responsePlan = this.workRecord;
                const workerRecord : Worker[] = responsePlan.workers.map((item: any) => {
                    return {
                        worker: {
                            id: item.worker.id, 
                            name: item.worker.name 
                        },
                        startWorktime: item.planStartWorktime,
                        planStartWorktime: item.planStartWorktime,
                        actualStartWorktime: item.actualStartWorktime,
                        endWorktime: item.planEndWorktime ,
                        planEndWorktime: item.planEndWorktime, 
                        actualEndWorktime: item.actualEndWorktime,
                        restTime:item.planRestTime,
                        planRestTime: item.planRestTime, 
                        actualRestTime: item.actualRestTime,
                        workTime: item.planWorkTime,
                        planWorkTime: item.planWorkTime, 
                        actualWorkTime: item.actualWorkTime,
                        quantity:item.quantity,
                        memo: item.memo,
                        kind: "SCHEDULE",
                        workerUpdatedTime : item.workerUpdatedTime
                    };
                });
                    const workRecordData = { ...responsePlan };
                    workRecordData.kind =this.workRecord.kind
                    workRecordData.workers = workerRecord;
                    this.workRecord = workRecordData;
            } 
        }  
    }

    async revertRecord(){
        this.cropFamicId = null;
        this.prevCropFamicId = null;
        this.cropFamicName = null;
        const res = toCamel(await this.$apiClient.doRequest('get', '/work_records/' + this.id)) as WorkRecordGet
        this.cropFamicId = res.cropFamicId;
        this.prevCropFamicId = res.cropFamicId;
        if(res.planting == null) {
            res.planting = {
                id: null,
                name: '作付を指定しない',
                crop: {
                    id: '',
                    name: '',
                    phonetic: ''
                }
            }
        }
        const workerRecord : Worker[] = res.workers.map((item: any) => {
            return {
                worker: {
                    id: item.worker.id, 
                    name: item.worker.name 
                },
                startWorktime: item.actualStartWorktime ? item.actualStartWorktime : item.planStartWorktime,
                planStartWorktime: item.planStartWorktime,
                actualStartWorktime: item.actualStartWorktime,
                endWorktime: item.actualEndWorktime ? item.actualEndWorktime :item.planEndWorktime,
                planEndWorktime: item.planEndWorktime, 
                actualEndWorktime: item.actualEndWorktime,
                restTime: item.actualRestTime === 0 ? item.actualRestTime :item.planRestTime,
                planRestTime: item.planRestTime, 
                actualRestTime: item.actualRestTime,
                workTime: item.actualWorkTime ? item.actualWorkTime :item.planWorkTime,
                planWorkTime: item.planWorkTime, 
                actualWorkTime: item.actualWorkTime,
                quantity:item.quantity,
                memo: item.memo,
                kind: item.kind,
                workerUpdatedTime : item.workerUpdatedTime
            };
        });
            const workRecordData = { ...res };
            workRecordData.workers = workerRecord;
            this.workRecord = workRecordData;
            this.getChemAppParts();
            this.getChemicalData();
            this.originalWorkers = this.workRecord.workers.map(w => ({...w}))
            this.originalMachines = this.workRecord.machines.map(m => ({...m}))
            this.workRecord.chemicals = this.workRecord.chemicals.map(c => ({...c , id:c.chemicalId})).sort((a, b) => {
                if (!a.warehouseName) return 1;
                if (!b.warehouseName) return -1;
        
                const warehouseCompare = a.warehouseName.localeCompare(b.warehouseName, "ja");
                if (warehouseCompare !== 0) {
                    return warehouseCompare;
                }
                return (a.name ?? "").localeCompare(b.name ?? "", "ja");
            });
            this.workRecord.chemicals = this.workRecord.chemicals.map(c => ({
                        ...c,
                        id: c.chemicalId,
                        prevUsageUnit: c.usageUnit
            }));
            this.originalChemicals = this.workRecord.chemicals.map(c => ({...c}))
            this.workRecord.fertilizers = this.workRecord.fertilizers.map(f => ({...f, id:f.fertilizerId})).sort((a, b) => {
                if (!a.warehouseName) return 1;
                if (!b.warehouseName) return -1;
        
                const warehouseCompare = a.warehouseName.localeCompare(b.warehouseName, "ja");
                if (warehouseCompare !== 0) {
                    return warehouseCompare;
                }
                return (a.fertilizerName ?? "").localeCompare(b.fertilizerName ?? "", "ja");
            });
            this.workRecord.fertilizers = this.workRecord.fertilizers.map(f => ({
                ...f,
                id: f.fertilizerId,
                prevUsageUnit: f.usageUnit
            }));
            this.originalFertilizers = this.workRecord.fertilizers.map(f => ({...f}))
            this.originalDepreciationMaterials = this.workRecord.depreciationMaterials.map(d => ({...d}))
            this.originalExpendableMaterials = this.workRecord.expendableMaterials.map(e => ({...e}))
        this.mode = 'edit'
        let workerInputTypeIsTimePoint
        if(this.workRecord.workers.length) {
            workerInputTypeIsTimePoint = this.workRecord.workers
                .map(w => w.startWorktime !== null && w.endWorktime !== null && w.restTime !== null)
                .reduce((res, b) => res && b)
        }
        this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
        let machineInputTypeIsTimePoint
        if(this.workRecord.machines.length) {
            machineInputTypeIsTimePoint = this.workRecord.machines
                .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                .reduce((res, b) => res && b)
        }
        this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'

        this.workRecord.imageId.forEach(imi => {
            this.$apiClient.doRequest('get', `${this.baseUrl}/${this.id}/images/${imi}/`).then(res => {
                const file = toCamel(res) as File
                this.images.push(file)
            })
        })

        this.recordInfo = {
            createdUser: this.workRecord.createdUser,
            created: this.workRecord.created.toString(),
            updatedUser: this.workRecord.updatedUser,
            updated: this.workRecord.updated.toString()
        }

        if(this.workRecord.workUnit!=null){
            this.workerGoalWorkUnitName = this.workRecord.workUnit.name
            this.selectedWorkUnitId = this.workRecord.workUnit.id
        }
    }

    async cancelRecord() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
            this.$store.dispatch('doUpdateIsInputChanged', false);
            if (this.id !== undefined && this.id !== '') {
                this.init()
                this.revertRecord()
            } else {
                this.init()
                this.cropItemIds= [];
            }
        }
    }

    private getWorkUnits() {
        this.$apiClient.doRequest('get', '/work_units?with_hidden=true&is_validate=false').then(res => {
            this.workunits = res.work_units
        }).catch(() => {
            this.$toasted.error('データの取得に失敗しました。');
        })
    }

    private getWorkerGoalWorkUnits(){
        if(this.workRecord.workItem.id!='' && this.workRecord.planting.id!='' && this.workRecord.agriField.id!=''){
            this.$apiClient.doRequest('get',`/admin/worker_goal_list/work_unit?workItem_id=${this.workRecord.workItem.id}&&planting_id=${this.workRecord.planting.id}&&agriField_id=${this.workRecord.agriField.id}&&work_date=${this.workRecord.workDate}`).then((res) => {
                this.workerGoalWorkUnitId = res.workerGoalWorkUnitId;
                this.selectedWorkUnitId = this.workerGoalWorkUnitId;
                if(this.workerGoalWorkUnitId!=null){
                    this.workerGoalWorkUnitName = this.workunits.find(item=>item.id==this.workerGoalWorkUnitId)?.name
                }else{
                    this.workerGoalWorkUnitName = ''
                }
            })
        }
    }

    private workUnitChange(){
        if(this.selectedWorkUnitId!=null){
            this.workerGoalWorkUnitName = this.workunits.find(item=>item.id==this.selectedWorkUnitId)?.name
        }else{
            this.workerGoalWorkUnitName = ''
        }
        this.workerGoalWorkUnitId = this.selectedWorkUnitId
        this.inputChanged();
    }

    get filteredWorkUnits() {
        return this.workunits.filter(wu => this.selectedWorkUnitId == wu.id || !wu.is_hidden)
    }

    toCamelCase = (str: string) => {
        return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
    };
    
    compareObject = (original: any, updated: any): boolean => {
        const updatedKeys = Object.keys(updated);
        for (const key of updatedKeys) {
            const originalKey = this.toCamelCase(key);
            if (Object.prototype.hasOwnProperty.call(original, originalKey) && Object.prototype.hasOwnProperty.call(updated, key)) {
                const origVal = original[originalKey];
                const updVal = updated[key];
                if (key === "ingSelConditions") {
                    if (!this.deepEqualArrayOfObjects(origVal, updVal)) {
                        return true;
                    }
                } else {
                    if (origVal !== updVal) {
                        return true;
                    }
                }
            }
        }
        return false;
    };

    deepEqualArrayOfObjects = (arr1: any[], arr2: any[]): boolean => {
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
        if (arr1.length !== arr2.length) return false;

        return arr1.every((obj1, idx) => {
            const obj2 = arr2[idx];
            return this.deepEqual(obj1, obj2);
        });
    };

    deepEqual = (obj1: any, obj2: any): boolean => {
        if (obj1 === obj2) return true;
        if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
            return false;
        }
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;

        return keys1.every(k => this.deepEqual(obj1[k], obj2[k]));
    }; 

    updateProcessType(data: WorkRecordPost) {
        const scheduleToActual = this.originalWorkRecord.kind != this.workRecord.kind;
        data.workers.forEach(worker => {
            const originalWorker = this.originalWorkers.find(w => w.worker.id === worker.worker_id);
            if (originalWorker) {
                if (this.compareObject(originalWorker, worker)) {
                    worker.processType = "UPDATE";
                }
            } else {
                worker.processType = "ADD";
            }
        });
    
        data.machines.forEach(machine => {
            const originalMachine = this.originalMachines.find(m => m.machine.id === machine.machine_id);
            if (originalMachine) {
                if (this.compareObject(originalMachine, machine)) {
                    machine.processType = "UPDATE";
                }
            } else {
                machine.processType = "ADD";
            }
        });
    
        data.chemicals.forEach(chemical => {
            const originalChemical = this.originalChemicals.find(c => c.chemicalId === chemical.chemical_id && c.warehouseId === chemical.warehouse_id);
            if (scheduleToActual) {
                chemical.processType = "UPDATE";
            } else if (originalChemical) {
                if (this.compareObject(originalChemical, chemical)) {
                    chemical.processType = "UPDATE";
                }
            } else {
                chemical.processType = "ADD";
            }
        });
    
        data.fertilizers.forEach(fertilizer => {
            const originalFertilizer = this.originalFertilizers.find(f => f.fertilizerId === fertilizer.fertilizer_id && f.warehouseId === fertilizer.warehouse_id);
            if (scheduleToActual) {
                fertilizer.processType = "UPDATE";
            } else if (originalFertilizer) {
                if (this.compareObject(originalFertilizer, fertilizer)) {
                    fertilizer.processType = "UPDATE";
                }
            } else {
                fertilizer.processType = "ADD";
            }
        });
        data.depreciation_materials.forEach(material => {
            const originalMaterial = this.originalDepreciationMaterials.find(m => m.itemId === material.item_id && m.warehouseId === material.warehouse_id);
            if (originalMaterial) {
                if (this.compareObject(originalMaterial, material)) {
                    material.processType = "UPDATE";
                }
            } else {
                material.processType = "ADD";
            }
        });
    
        data.expendable_materials.forEach(material => {
            const originalMaterial = this.originalExpendableMaterials.find(m => m.materialId === material.material_id && m.warehouseId === material.warehouse_id);
            if (scheduleToActual) {
                material.processType = "UPDATE";
            } else if (originalMaterial) {
                if (this.compareObject(originalMaterial, material)) {
                    material.processType = "UPDATE";
                }
            } else {
                material.processType = "ADD";
            }
        });
        return data;
    }

    handleChemicalAddSettingsChange(chemical: ChemicalRecord) {
        chemical.dilRatio = null;
        chemical.sprayQty = null;
        chemical.shares = null;
        chemical.dilRatioUnit = "倍";
        chemical.sprayUnit = "L";
        chemical.appPartBranchNum = null;
        chemical.usageCountBranchNum = null;
        chemical.dilRatioBranchNum = null;
        chemical.sprayQtyBranchNum = null;
        chemical.ingSelConditions = [];
        if (chemical.addSettings) {
            const id = Number(chemical.chemicalId || chemical.id);
            const capList = this.caps[id] || [];
            if (capList.length === 1) {
                const cap = capList[0];
                chemical.appPartBranchNum = cap.branchNum;
                chemical.isNotSuitable = cap.isNotSuitable || false;
                if ((cap.usageConditions?.length || 0) === 1) {
                    chemical.usageCountBranchNum = cap.usageConditions[0].branchNum;
                }
                if ((cap.dilutionConditions?.length || 0) === 1) {
                    chemical.dilRatioBranchNum = cap.dilutionConditions[0].branchNum;
                    chemical.dilRatioUnit = cap.dilutionConditions[0].unit;
                }
                if ((cap.sprayConditions?.length || 0) === 1) {
                    chemical.sprayQtyBranchNum = cap.sprayConditions[0].branchNum;
                    chemical.sprayUnit = cap.sprayConditions[0].unit;
                }
                if (cap.ingConditions?.length) {
                    cap.ingConditions.forEach((ing: { branchNum: number; conditions: any[]; }) => {
                        if ((ing.conditions?.length || 0) === 1) {
                            const detail = ing.conditions[0];
                            chemical.ingSelConditions.push({
                                chemicalId: cap.chemicalId,
                                isExpired: detail.isExpired,
                                name: detail.name,
                                basicBranchNum: ing.branchNum,
                                ingUsageCntBranchNum: detail.branchNum,
                                usageCountOrigin: detail.value,
                                usageCount: detail.usageCount
                            } as SelCondition);
                        }
                    });
                }
            }
        }
        this.inputChanged();
    }
      
    isSameUnitLevel(unitA: string, unitB: string): boolean {
        const heavy = ['kg', 'L'];
        const light = ['g', 'mL', 'cc'];
        return ((heavy.includes(unitA) && heavy.includes(unitB)) ||
            (light.includes(unitA) && light.includes(unitB)));
    }
    
    getFertUnit(unit: string) {
       return this.fertilizerUnits?.find(u => u.name === unit);
    }

    getChemUnit(unit: string) {
       return this.chemicalUnits?.find(u => u.name === unit);
    }

    //ConvertChemical
    convertToKgLChem(value: number, unit: string): number {
        const chemUnit = this.getChemUnit(unit);
        if (!chemUnit || !chemUnit.weight_per_unit) {
            return value;
        }
        return value * chemUnit.weight_per_unit;
    }
      
    convertFromKgLChem(value: number, unit: string): number {
        const chemUnit = this.getChemUnit(unit);
        if (!chemUnit || !chemUnit.weight_per_unit) {
            return value;
        }
        return value / chemUnit.weight_per_unit;
    }

    //ConvertFertilizer
    convertToKgLFert(value: number, unit: string): number {
        const fertUnit = this.getFertUnit(unit);
        if (!fertUnit || !fertUnit.weight_per_unit) {
            return value;
        }
        return value * fertUnit.weight_per_unit;
    }
      
    convertFromKgLFert(value: number, unit: string): number {
        const fertUnit = this.getFertUnit(unit);
        if (!fertUnit || !fertUnit.weight_per_unit) {
            return value;
        }
        return value / fertUnit.weight_per_unit;
    }

    autoCalculation(index: number, key: 'dil' | 'spray' | 'usage') {
        this.inputChanged();
        const chemical = this.workRecord.chemicals[index];
        if (!chemical) return;
      
        if (chemical.dilRatioUnit != "倍") return;
        if (!['mL', 'L', 'cc'].includes(chemical.sprayUnit)) return;
      
        const dil = Number(chemical.dilRatio) || null;
        const sprayQty = Number(chemical.sprayQty) || null;
        const usageQty = Number(chemical.usage) || null;
        const sprayUnit = chemical.sprayUnit || null;
        const usageUnit = chemical.usageUnit || null;
      
        const values = { dil, spray: sprayQty, usage: usageQty };
        const filledKeys = Object.entries(values)
          .filter(([, v]) => v != null)
          .map(([k]) => k as 'dil' | 'spray' | 'usage');
      
        if ((filledKeys.length === 3 && !this.currentKey) || (filledKeys.length === 2 && !this.currentKey && !filledKeys.includes(key))) {
            if (key === 'dil') {
                chemical.sprayQty = null;
                chemical.usage = null;
            } else if (key === 'spray') {
                chemical.dilRatio = null;
                chemical.usage = null;
            } else if (key === 'usage') {
                chemical.dilRatio = null;
                chemical.sprayQty = null;
            }
            this.currentKey = key;
            return;
        }
      
        const sameUnit = sprayUnit && usageUnit && this.isSameUnitLevel(sprayUnit, usageUnit);
      
        if (key === 'dil' && dil && dil > 0) {
            if (usageQty && sprayUnit && usageUnit) {
                const result = usageQty * dil;
                chemical.sprayQty = sameUnit
                ? result > 0 ? result : null
                : (() => {
                    const sprayKg = this.convertToKgLChem(usageQty, usageUnit) * dil;
                    const converted = this.convertFromKgLChem(sprayKg, sprayUnit);
                    return converted > 0 ? converted : null;
                    })();
            } else if (sprayQty && sprayUnit && usageUnit) {
                const result = sameUnit
                ? sprayQty / dil
                : this.convertFromKgLChem(this.convertToKgLChem(sprayQty, sprayUnit) / dil, usageUnit);
                chemical.usage = result > 0 ? result : null;
            }
        } else if (key === 'spray' && sprayQty && sprayUnit && usageUnit) {
            if (usageQty && usageQty > 0) {
                const result = sameUnit
                ? sprayQty / usageQty
                : this.convertToKgLChem(sprayQty, sprayUnit) / this.convertToKgLChem(usageQty, usageUnit);
                chemical.dilRatio = result > 0 ? result : null;
            } else if (dil && dil > 0) {
                const result = sameUnit
                ? sprayQty / dil
                : this.convertFromKgLChem(this.convertToKgLChem(sprayQty, sprayUnit) / dil, usageUnit);
                chemical.usage = result > 0 ? result : null;
            } 
        } else if (key === 'usage' && usageQty && usageQty > 0 && sprayUnit && usageUnit) {
            if (dil && dil > 0) {
                const result = usageQty * dil;
                chemical.sprayQty = sameUnit
                ? result > 0 ? result : null
                : (() => {
                    const sprayKg = this.convertToKgLChem(usageQty, usageUnit) * dil;
                    const converted = this.convertFromKgLChem(sprayKg, sprayUnit);
                    return converted > 0 ? converted : null;
                    })();
            } else if (sprayQty) {
                const result = sameUnit
                ? sprayQty / usageQty
                : this.convertToKgLChem(sprayQty, sprayUnit) / this.convertToKgLChem(usageQty, usageUnit);
                chemical.dilRatio = result > 0 ? result : null;
            }
        }
        this.currentKey = key;
    }
      
    convertUnitChem(value: number, fromUnit: string, toUnit: string): number {
        const baseValue = this.convertToKgLChem(value, fromUnit);
        return this.convertFromKgLChem(baseValue, toUnit);
    }

    convertUnitFert(value: number, fromUnit: string, toUnit: string): number {
        const baseValue = this.convertToKgLFert(value, fromUnit);
        return this.convertFromKgLFert(baseValue, toUnit);
    }
      
    unitChange(index: number, key: 'dil' | 'spray' | 'usage') {
        this.inputChanged();
        const chemical = this.workRecord.chemicals[index];
        if (!chemical) return;
      
        const dil = Number(chemical.dilRatio) || null;
        const spray = Number(chemical.sprayQty) || null;
        const usage = Number(chemical.usage) || null;
        const sprayUnit = chemical.sprayUnit || null;
        const usageUnit = chemical.usageUnit || null;

        if (chemical.dilRatioUnit != "倍") return;
        if (!['mL', 'L', 'cc'].includes(chemical.sprayUnit)) return;
      
        if (!dil || !spray || !usage || !sprayUnit || !usageUnit) {
            this.handleUnitChange(index,'chemical');
            return;
        }
        const sameUnit = this.isSameUnitLevel(sprayUnit, usageUnit);
      
        if (key === 'usage') {
            let result = spray / dil;
            if (!sameUnit) result = this.convertUnitChem(result, sprayUnit, usageUnit);
            chemical.usage = result;
        } else if (key === 'spray') {
            let result = usage * dil;
            if (!sameUnit) result = this.convertUnitChem(result, usageUnit, sprayUnit);
            chemical.sprayQty = result;
        } else if (key === 'dil') {
            const sprayBase = sameUnit ? spray : this.convertToKgLChem(spray, sprayUnit);
            const usageBase = sameUnit ? usage : this.convertToKgLChem(usage, usageUnit);
            const result = usageBase > 0 ? sprayBase / usageBase : null;
            chemical.dilRatio = result;
        }
    }
    
    openPesticideUsageModal(index: number) {
        this.currentChemicalCell = null;
        if (this.cropFamicId !== null) {
            const cvhc = this.workRecord.chemicals[index];
            if (!cvhc) return;
            const currentDisiDiv = cvhc.disiDiv;
            const normalizedDisiDiv = currentDisiDiv === 1 || currentDisiDiv === 2 || currentDisiDiv === 3 ? currentDisiDiv : 2;
            this.currentChemicalCell = {
                id: cvhc?.workRecordChemicalId ?? null,
                chemicalId: cvhc.chemicalId || cvhc.id,
                chemicalName: cvhc.chemicalDisplayName || cvhc.name,
                appPartBranchNum: cvhc?.appPartBranchNum ?? null,
                usageCountBranchNum: cvhc?.usageCountBranchNum ?? null,
                dilRatioBranchNum: cvhc?.dilRatioBranchNum ?? null,
                sprayQtyBranchNum: cvhc?.sprayQtyBranchNum ?? null,
                warehouseId: cvhc.warehouseId,
                warehouseName: cvhc.warehouseName ?? "未管理",
                workRecordId: this.id ?? null,
                workDate: this.workRecord.workDate ?? null,
                usageQty: cvhc.usage ?? null,
                usageUnit: cvhc.usageUnit ?? "kg",
                sprayQty: cvhc.sprayQty ?? null,
                sprayUnit: cvhc?.sprayUnit ?? "L",
                dilRatio: cvhc.dilRatio ?? null,
                dilRatioUnit: cvhc.dilRatioUnit ?? "倍",
                unitOfMeasure: cvhc.unitOfMeasure ?? 0,
                disiDiv: normalizedDisiDiv,
                shares: cvhc.shares ?? null,
                usedDates: [],
                editable: false,
                isNotSuitable: cvhc.isNotSuitable ?? false,
                cropId: null,
                isExpired: false,
                ingSelConditions: cvhc?.ingSelConditions ?? [],
                amount: cvhc.amount ?? null,
            };
            this.showPesticideUsageModal = true;
        } else {
            window.alert('作付の品種（種苗）で品目を設定してください。');
            return;
        }
    }

    commitChemicalUsage(usage: ChemicalWorkUsage | null) {
        this.inputChanged();
        if (!this.currentChemicalCell) return;
        const { chemicalId, warehouseId } = this.currentChemicalCell;
        const i = this.workRecord.chemicals.findIndex(c => (c.id ?? c.chemicalId) === chemicalId && c.warehouseId === warehouseId);
        if (usage) {
            const chemical = this.workRecord.chemicals[i];
            if (!chemical) return;
            chemical.appPartBranchNum = usage.appPartBranchNum;
            chemical.usageCountBranchNum = usage.usageCountBranchNum;
            chemical.dilRatioBranchNum = usage.dilRatioBranchNum;
            chemical.sprayQtyBranchNum = usage.sprayQtyBranchNum;
            chemical.disiDiv = usage.disiDiv;
            chemical.unitOfMeasure = usage.unitOfMeasure;
            chemical.sprayQty = usage.sprayQty;
            chemical.sprayUnit = usage.sprayUnit ?? "L";
            chemical.dilRatio = usage.dilRatio;
            chemical.dilRatioUnit = usage.dilRatioUnit ?? "倍";
            chemical.usage = usage.usageQty;
            chemical.usageUnit = usage.usageUnit;
            chemical.shares = usage.shares;
            chemical.ingSelConditions = usage.ingSelConditions;
            chemical.amount = usage.amount;
            chemical.isNotSuitable = usage.isNotSuitable;
            chemical.usageCount = usage.usageCount;
            chemical.usageCountOrigin = usage.usageCountOrigin
        } else {
            if (i !== -1) {
                this.workRecord.chemicals.splice(i, 1)
            }
        }
        this.currentChemicalCell = null;
    }

    getConditionMsg(chemical: ChemicalRecord): boolean {
        const id = Number(chemical.id ?? chemical.chemicalId);
        if (!id) return false;

        const caps: any[] = this.caps[id] || [];
        if (caps.length === 0) return false;

        const cap = caps.find(c => c.branchNum === chemical.appPartBranchNum) || caps[0];

        const isIngredientSelected = (): boolean => {
            if (!cap.ingConditions || cap.ingConditions.length === 0) return true;

            if (!chemical.ingSelConditions || chemical.ingSelConditions.length === 0) return false;

            return cap.ingConditions.every((capIng: { branchNum: number; conditions: any[]; }) => {
                const sel = chemical.ingSelConditions.find(
                    selCond => selCond.basicBranchNum === capIng.branchNum
                );

                if (!sel) return false;

                const match = capIng.conditions?.some(detail =>
                    detail.branchNum === sel.ingUsageCntBranchNum &&
                    detail.chemicalId === sel.chemicalId
                );

                return !!match && sel.ingUsageCntBranchNum != null;
            });
        };

        const conditions = [
            { name: 'appPart', hasOptions: caps.length > 0, isSelected: chemical.appPartBranchNum != null },
            { name: 'usage', hasOptions: (cap.usageConditions?.length || 0) > 0, isSelected: chemical.usageCountBranchNum != null },
            { name: 'dilution', hasOptions: (cap.dilutionConditions?.length || 0) > 0, isSelected: chemical.dilRatioBranchNum != null },
            { name: 'spray', hasOptions: (cap.sprayConditions?.length || 0) > 0, isSelected: chemical.sprayQtyBranchNum != null },
            { name: 'ingredient', hasOptions: (cap.ingConditions?.length || 0) > 0, isSelected: isIngredientSelected() },
        ];

        return conditions.some(cond => cond.hasOptions && !cond.isSelected);
    }

    async getChemAppParts () {
        if (this.workRecord?.planting?.id) {
            await this.$apiClient.doRequest('get', `${this.baseUrl}/plantings/${this.workRecord.planting.id}`).then(res => {
                this.cropFamicId = res.id || null;
                this.cropFamicName = res.name || null;
                this.caps = (res.caps || []).reduce((acc: Record<number, any[]>, cap: any) => {
                    const chemicalId = Number(cap.chemicalId);
                    if (!chemicalId) return acc;
                    if (!acc[chemicalId]) {
                        acc[chemicalId] = [];
                    }
                    acc[chemicalId].push(cap);
                    return acc;
                }, {} as Record<number, any[]>);
                this.workRecord.chemicals.forEach(chemical => {
                    if (chemical.addSettings && (!chemical.appPartBranchNum)) {
                        const id = Number(chemical.chemicalId || chemical.id);
                        const capList = this.caps[id] || [];
                        if (capList.length === 1) {
                            const cap = capList[0];
                            chemical.appPartBranchNum = cap.branchNum;
                            chemical.isNotSuitable = cap.isNotSuitable || false;
                            if ((cap.usageConditions?.length || 0) === 1) {
                                chemical.usageCountBranchNum = cap.usageConditions[0].branchNum;
                            }
                            if ((cap.dilutionConditions?.length || 0) === 1) {
                                chemical.dilRatioBranchNum = cap.dilutionConditions[0].branchNum;
                                chemical.dilRatioUnit = cap.dilutionConditions[0].unit || "倍";
                            }
                            if ((cap.sprayConditions?.length || 0) === 1) {
                                chemical.sprayQtyBranchNum = cap.sprayConditions[0].branchNum;
                                chemical.sprayUnit = cap.sprayConditions[0].unit || "L";
                            }
                            if (cap.ingConditions?.length) {
                                cap.ingConditions.forEach((ing: { branchNum: number; conditions: any[]; }) => {
                                    if ((ing.conditions?.length || 0) === 1) {
                                        const detail = ing.conditions[0];
                                        chemical.ingSelConditions.push({
                                            chemicalId: cap.chemicalId,
                                            isExpired: detail.isExpired,
                                            name: detail.name,
                                            basicBranchNum: ing.branchNum,
                                            ingUsageCntBranchNum: detail.branchNum,
                                            usageCountOrigin: detail.value,
                                            usageCount: detail.usageCount
                                        } as SelCondition);
                                    }
                                });
                            }
                        }
                    }
                });
            }).catch(() => {
                this.$toasted.error('データの取得に失敗しました。');
                this.cropFamicId = null;
                this.cropFamicName = null;
            });
        }
    }

    getChisso(fertilizerItem : FertilizerRecord): string {
        const { usage, chemRetio: r, usageUnit: u, unitOfMeasure: m } = fertilizerItem;
        const q = Number(usage);
        if (!q || !r || !u) return '---';
        const fertUnit = this.fertilizerUnits?.find(unit => unit.name === u);
        const qtyInKg = q * fertUnit.weight_per_unit;
        return `${this.formatNumberWithCommas((qtyInKg * r) / 100)} kg${m === 1 ? '/10a' : ''}`;
    }

    formatNumberWithCommas = (v: number) => (v % 1 ? v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : v.toLocaleString());

    async getChemicalData() {
        if (this.workRecord?.planting?.id && this.workRecord?.agriField?.id) {
            const idSegment = this.id && this.mode === 'edit' ? `/${this.id}` : '';
            await this.$apiClient.doRequest('get', `${this.baseUrl}/chemical_data/${this.workRecord.planting.id}/${this.workRecord.agriField.id}${idSegment}`).then(res => {
                this.chemicalData = Array.isArray(res?.workUsages) ? res.workUsages : [];
            }).catch((e) => {
                this.$toasted.error('データの取得に失敗しました。');
            });
        }
    }

    get maxUsageAlerts(): Record<number, string> {
        const chemicalData: any[] = Array.isArray(this.chemicalData) ? this.chemicalData : [];
        const combinedData = [
            ...chemicalData,
            ...this.workRecord.chemicals.map((chem: any) => ({
                chemicalId: chem.chemicalId || chem.id,
                disiDiv: chem.disiDiv,
                usageCountOrigin: chem.usageCountOrigin,
                usageCount: chem.usageCount,
                ingredients: chem.ingredients
            })),
        ];

        const { usageCounter, limitMap } = combinedData.reduce((acc, item) => {
            const key = `${item.chemicalId}|${item.disiDiv}|${item.usageCountOrigin ?? "NOTSET"}`;
            const totalPointValue = (item.ingredients ?? []).reduce((sum: number, ing: any) => sum + ing.pointValue, 0);

            const usage = (totalPointValue > 0 ? 1 : 0);
            acc.usageCounter[key] = (acc.usageCounter[key] ?? 0) + usage;
            if (item.usageCount != null && acc.limitMap[key] == null) {
                acc.limitMap[key] = item.usageCount;
            }
            return acc;
        }, {
            usageCounter: {} as Record<string, number>,
            limitMap: {} as Record<string, number>
        });

        const exceeded = new Set(Object.keys(usageCounter).filter(k => limitMap[k] != null && usageCounter[k] > limitMap[k]));
        return this.workRecord.chemicals.reduce((alerts: Record<number, string>, chem: any, index: number) => {
            const key = `${chem.chemicalId || chem.id}|${chem.disiDiv}|${chem.usageCountOrigin ?? "NOTSET"}`;
            alerts[index] = exceeded.has(key) ? '農薬使用回数上限値を超えました。' : '';
            return alerts;
        }, {} as Record<number, string>);
    }

    get maxIngUsageAlerts(): Record<number, string> {
        const chemicalData: any[] = Array.isArray(this.chemicalData) ? this.chemicalData : [];
        const combinedData = [
            ...chemicalData,
            ...this.workRecord.chemicals.map((chem: any) => ({
                chemicalId: chem.chemicalId || chem.id,
                disiDiv: chem.disiDiv,
                usageCountOrigin: chem.usageCountOrigin,
                ingredients: chem.ingredients || [],
                ingSelConditions: chem.ingSelConditions || [],
            })),
        ];

        const usageCounter: Record<string, number> = {};
        const limitMap: Record<string, number> = {};

        combinedData.forEach((chem: any) => {
            (chem.ingSelConditions || []).forEach((cond: any) => {
                if (cond.usageCount == null) return;
                const key = `${cond.name}|${chem.disiDiv}|${chem.usageCountOrigin ?? 'NOTSET'}|${cond.usageCountOrigin ?? 'NOTSET'}`;
                const pointValue = (chem.ingredients || []).find((ing: any) => ing.name === cond.name)?.pointValue ?? 0;
                const usage = (pointValue > 0 ? 1 : 0);
                usageCounter[key] = (usageCounter[key] ?? 0) + usage;
                if (limitMap[key] == null) {
                    limitMap[key] = cond.usageCount;
                }
            });
        });

        const exceeded = new Set(Object.keys(usageCounter).filter(k => limitMap[k] != null && usageCounter[k] > limitMap[k]));
        return this.workRecord.chemicals.reduce((alerts: Record<number, string>, chem: any, index: number) => {
            const hasExceeded = (chem.ingSelConditions || []).some((cond: any) => {
                const key = `${cond.name}|${chem.disiDiv}|${chem.usageCountOrigin ?? 'NOTSET'}|${cond.usageCountOrigin ?? 'NOTSET'}`;
                return exceeded.has(key);
            });

            alerts[index] = hasExceeded ? '成分使用回数上限値を超えました。' : '';
            return alerts;
        }, {} as Record<number, string>);
    }

    getChemicalUnits() {
        this.$apiClient.doRequest('get','/unit_conversion/chemicals').then((res) => {
        this.chemicalUnits = res.weight_units
        })
    }

    getFertilizerUnits() {
        this.$apiClient.doRequest('get','/unit_conversion/fertilizer').then((res) => {
        this.fertilizerUnits = res.weight_units
        })
    }

    isSprayUnitSelectable(unit: string): boolean {
        return ['mL', 'L', 'cc'].includes(unit);
    }

    isDilUnitSelectable(unit: string): boolean {
        return ['倍', 'ppm'].includes(unit);
    }

    truncateText(text: string | null | undefined, maxLength: number): string {
        const safeText = text || '';
        if (safeText.length > maxLength) {
            return safeText.substring(0, maxLength) + '...';
        }
        return safeText;
    }

    isUnitDisabled(unitName: string, id: string): boolean {
        return !!id && !this.chemicalUnits.some(u => u.name === unitName && u.weight_per_unit !== null);
    }

    getWarehouseChemicals() {
        if (!this.tenantId) return;
        this.$apiClient.doRequest('get', `/admin/warehouses/warehouse_chemicals/${this.tenantId}`).then((res) => {
            this.warehouseChemicals = res.warehouseChemicals || [];
        })
    }

    filteredChemicalUnits(chemicalId: number, warehouseId: string | null): any[] {
        if (!chemicalId) return this.chemicalUnits;
        const wc = this.warehouseChemicals.find(w => w.chemicalId === chemicalId && (w.warehouseId === warehouseId || w.warehouseName === '未管理'));
        if (!wc) return this.chemicalUnits;
        const isWeightNull = wc.weightPerUnit == null;
        return this.chemicalUnits.filter(unit => isWeightNull ? unit.weight_per_unit == null : unit.weight_per_unit != null);
    }

    get isReferenceOnly(): boolean {
        return this.$store.getters.loginUser?.pdWhsRecRefOnly === true;
    }
}
